import React from "react";
import './standard-classwork-experience.scss';
// import SharedProfile from "../../../../shared-storage/profile";
import CommonUtils from "../../utility/common-utilities";
import HomeworkApi from "../../apis/homework";
// import AssessmentHeader from "../../common/assessment-header/assessment-header";
import Question from "../../components/clicker-flow-practice-v3/question/question";
import SuccessFailureScreen from '../../components/clicker-flow-practice-v3/practice-end-screen/practice-end-screen';
// import ConceptList from "../my-classwork-V1/classwork-concept-list-screen/classwork-concept-list";
// import HomeworkConceptList from '../my-homework/classwork-concept-list-screen/classwork-concept-list';
import { Constants } from "../../constants/constants";
// import FireBaseEvent from '../../firebase-events/firebase-events';
import LayoutShared from "../../components/common/layout-shared/layout-shared";
import Loading from "../../components/common/loading/loading";
import HomeworkForClickerPracticeApi from "../../apis/homework-for-clicker-practice";
import IndexedDBHelperV2 from "../apis/indexDBManager-v2";
const dbHelper = new IndexedDBHelperV2(Constants.DB_NAME, Constants.DB_VERSION, Constants.STORE_CONFIG);


export const ClickerPracticeConTextOffline = React.createContext({ disableNext: false, index: 0 })


export default class WorkflowExperience extends React.Component {

    workflowEngine = null;
    worflowNodes = [];
    questions = [];
    assessedResponse = {};
    multiStepTimeListHash = {}
    state = {
        questions: [],
        studentList: this.props.studentList,
        answers: [],
        learningElos: [],
        showSuccessFailureScreen: false,
        stepIndex: 0,
        showHint: false,
        showSolvedExamplesModal: false,
        showInvalidAnswerModal: false,
        showCorrectIncorrectModal: false,
        showCorrectAnswer: false,
        isReadOnly: false,
        disableNext: false,
        toastText: "",
        questionLoading: true,
        currentQuestionNumber: 0,
        currentIndex: 0, // Introduced this key to keep track of current Index when we go previous and comeback to stop there
        showPreviousQuestion: false,
        showMainQuestion: true,
        isResume: false
    };
    questionComponent = null;
    successFailureScreenData = {
    };

    params = {

    }

    isRevise = false;

    isCorrect = false;
    eloIds = []

    constructor(props) {
        super(props);

        this.params = this.props.params
        this.layoutShared = LayoutShared.getLayout()

        console.log(this.params, 'offline')
    }

    componentDidMount() {


        if (this.params.status != 'ASSIGNED') {
            this.toggleLayoutBar()
        }

        this.getAssessmentContent((err, data) => {
            if (err) {
                return;
            }

            console.log(data)

            this.setQuestion(data);
        });

        // if (!this.userInfo.isSubscribed) {
        //     this.showTimerPauseToast()

        //     this.props.navigation.addListener("didFocus", () => {
        //         AppState.addEventListener('change', this._handleAppStateChange);
        //     });

        //     this.props.navigation.addListener("didBlur", () => {
        //         AppState.removeEventListener('change', this._handleAppStateChange);
        //     });

        // }

        // BackHandler.addEventListener('hardwareBackPress', this.backhandler);
        this.setZoomOut()

    }

    setZoomOut() {
        if (window.electron) {
            // console.log('called Zoom out')
            window.electron.ipcRenderer.send('zoom-out', ['ping'])
        }
    }

    toggleLayoutBar() {
        // console.log('toggle called')

        // this.setState({hideLayoutSideBar : !this.state.hideLayoutSideBar}, () => {
        this.layoutShared.showHideLayoutBar(!this.layoutShared.state.showLayoutBar)
        window.electron.ipcRenderer.send('toggle-fullscreen', ['ping']);
        // this.layoutShared.toggleSidebar(this.state.hideLayoutSideBar)
        // })

    }


    backhandler = () => {
        // BackHandler.removeEventListener('hardwareBackPress', this.backhandler);
        return true
    }

    // _handleAppStateChange = (state) => {
    //     if ((state == constants.APP_STATE_BACKGROUND && Platform.OS == 'android') || (state == constants.APP_STATE_IN_ACTIVE && Platform.OS == 'ios')) {
    //         HomeworkShared.setHomeworkPageStatus(true)
    //     }
    // }

    getAssessmentContent = (callback) => {

        let homeworkId = this.params.homeworkId
        let nodeId = this.params.nodeId

        let metaInfo = {};

        metaInfo.experienceType = "CLICKER_PRACTICE";
        metaInfo.activity = {
            type: "CLICKER_PRACTICE",
            version: 1
        }

        let payload = {
            nodeId: this.params.nodeId,
            homeworkId: this.params.homeworkId
        };

        let userIds = [], teacherUserId = ''

        this.props.studentList.map(item => {
            if (!item.isTeacher) {
                userIds.push(item.userId)
            } else {
                teacherUserId = item.userId
            }
        })

        if (userIds.length) {
            payload.userIds = userIds.join(',')
        }


        // let userObjectIdList = payload.userIds.split(',').map(item => ObjectID(item))

        let userIdNodeIdHomeworkId = teacherUserId + payload.nodeId + payload.homeworkId



        dbHelper.getData(Constants.USER_HOMEWORK_NODE_ACTIVITY_STORE, userIdNodeIdHomeworkId).then(nodeActivities => {

            console.log('node activities', nodeActivities)

            dbHelper.getData(Constants.HOMEWORK_STORE, homeworkId).then(homeworkData => {

                let assessmentQuestionType = homeworkData.assessmentQuestionType
                let contentsHash = homeworkData.contentsHash


                if (!nodeActivities) {

                    let homeworkNodeQuery = {
                        homeworkId
                    };



                    dbHelper.getData(Constants.HOMEWORK_NODES_STORE, nodeId).then(nodes => {
                        console.log(nodes)
                        nodes = [nodes]
                        if (nodes.length > 0) {

                            let nodeActivity = this.createNodeActivity(teacherUserId, nodes[0], homeworkId, metaInfo);

                            // Store Node Activity for the First Time

                            dbHelper.updateBulkData(Constants.USER_HOMEWORK_NODE_ACTIVITY_STORE, nodeActivity).then((status) => {

                                nodeActivity = nodeActivity[0]

                                // Update Teacher Homework Acticity
                                dbHelper.getAllFromIndex(Constants.TEACHER_HOMEWORK_ACTIVITY_STORE, 'homeworkId', homeworkId).then((teacherActivityData) => {

                                    teacherActivityData[0].status = 'IN_PROGRESS'

                                    dbHelper.updateBulkData(Constants.TEACHER_HOMEWORK_ACTIVITY_STORE, teacherActivityData).then(updatedTeacherActivity => {

                                        let usersList = this.props.studentList

                                        // let eloQuery = { _id: ObjectID(nodeActivity.resume.eloId) };
                                        // Get Elo Details 

                                        dbHelper.getData(Constants.ELO_STORE, nodeActivity.resume.eloId).then((eloDetails) => {

                                            eloDetails = [eloDetails]

                                            console.log(eloDetails)

                                            let assessmentQuestionsIds = this.prepareQueryForAssessmentContent(eloDetails[0]);
                                            let assessmentQuestionsMetadataIds = this.prepareQueryForAssessmentMetadata(eloDetails[0]);
                                            let elo = eloDetails[0];
                                            let videoContentUrl = ''

                                            assessmentQuestionsIds = assessmentQuestionsIds.filter(item => item != undefined)

                                            console.log(assessmentQuestionsIds)

                                            dbHelper.getAllByIds(Constants.CONTENTS_STORE, assessmentQuestionsIds).then((assessmentContents) => {

                                                assessmentQuestionsMetadataIds = assessmentQuestionsMetadataIds.filter(item => item != undefined)

                                                dbHelper.getAllByIds(Constants.CONTENT_META_DATA_STORE, assessmentQuestionsMetadataIds).then(contentMetaData => {

                                                    let questions = []

                                                    questions = assessmentContents ? assessmentContents : []


                                                    console.log(questions)

                                                    // To not show the Type 7 Labeling Questions // Show only Single Select Questions from Worksheet masterdata

                                                    questions = questions.filter(question => {
                                                        return (question.content.type === 1 || (question.content.isMultiStep && question.content.practice && question.content.practice.id === 'CASE STUDY'))
                                                    }
                                                    )



                                                    if (questions.length == 0) {
                                                        console.log("Question Filter : No Question can be presented in this ELO <", elo["_id"].toString(), ">");
                                                        console.log('No Questios Found')
                                                        // Responder.sendResponse(StatusCode.SERVER_ERROR, { message: "Internal error" }, res, req);
                                                        return;
                                                    }

                                                    if (assessmentQuestionType === 'SELECTED_ASSESSMENT_QUESTIONS' && contentsHash) {
                                                        questions = questions.filter(item => contentsHash[item._id.toString()] === true)
                                                    }

                                                    // To update Image in Offline 

                                                    questions.forEach(contentItem => {
                                                        let content = contentItem.content
                                                        if (content.images && content.images.length) {
                                                            content.images.forEach(item => {
                                                                delete item.imageUrl
                                                                item.imageUrl = URL.createObjectURL(item.imageBlob)
                                                            })
                                                        }

                                                        if (content.options && content.options.length) {
                                                            content.options.forEach(option => {
                                                                if (option.contentTypeName === 'IMAGE' && option.imageBlob) {
                                                                    delete option.content
                                                                    option.content = URL.createObjectURL(option.imageBlob)
                                                                }
                                                            })
                                                        }


                                                        // For Multi Step

                                                        if (content.isMultiStep && content.steps && content.steps.length) {
                                                            content.steps.forEach(stepContentItem => {
                                                                let stepContent = stepContentItem.content
                                                                if (stepContent.images && stepContent.images.length) {
                                                                    stepContent.images.forEach(item => {
                                                                        delete item.imageUrl
                                                                        item.imageUrl = URL.createObjectURL(item.imageBlob)
                                                                    })
                                                                }

                                                                if (stepContent.options && stepContent.options.length) {
                                                                    stepContent.options.forEach(option => {
                                                                        if (option.contentTypeName === 'IMAGE' && option.imageBlob) {
                                                                            delete option.content
                                                                            option.content = URL.createObjectURL(option.imageBlob)
                                                                        }
                                                                    })
                                                                }

                                                            })
                                                        }

                                                        // For Summary Solution

                                                        if (content.solutionSteps.summarySolutionImagesMap) {
                                                            let imagesMap = content.solutionSteps.summarySolutionImagesMap
                                                            let html = content.solutionSteps.summarySolution
                                                            const dom = new DOMParser().parseFromString(html, "text/html");
                                                            const imgs = dom.querySelectorAll("img");
                                                            console.log(imgs)
                                                            imgs.forEach(img => {
                                                                const src = img.getAttribute("src");
                                                                // console.log(src)
                                                                const blob = imagesMap[src]
                                                                // console.log(typeof imagesMap[src]); // must NOT be "string"
                                                                // console.log(blob instanceof Blob);  // must be true
                                                                // console.log(blob.size);
                                                                // const blobUrl = URL.createObjectURL(blob);
                                                                img.src = URL.createObjectURL(blob);
                                                                console.log(img)
                                                                // img.setAttribute("src", blobUrl);
                                                            })
                                                            content.solutionSteps.summarySolution = dom.body.innerHTML;
                                                        }

                                                        // console.log(content.solutionSteps.summarySolution)

                                                    })


                                                    let questionsByCategory = this.groupByQuestionCategory(questions, contentMetaData, homeworkId);

                                                    let categories = Object.keys(questionsByCategory);
                                                    categories = categories.sort();

                                                    if (categories.length > 0) {
                                                        let eloActivityPayload = {
                                                            userIdNodeIdHomeworkId,
                                                            nodeId: nodeActivity.nodeId,
                                                            // questionCategory: 'M1',
                                                            eloId: elo["_id"].toString(),
                                                            attemptNumber: 1,
                                                            answers: {},
                                                            studentAnswers: {},
                                                            type: "PRIMARY",
                                                            status: "IN_PROGRESS",
                                                            createdDate: new Date(),
                                                            homeworkId: nodeActivity.homeworkId,

                                                            userId: teacherUserId,
                                                            class: teacherActivityData[0].class,
                                                            schoolId: teacherActivityData[0].schoolId,
                                                            // school: teacherActivityData[0].school,
                                                            board: teacherActivityData[0].board,
                                                            // boardId: teacherActivityData[0].boardId,
                                                            section: teacherActivityData[0].section,
                                                            masterDataId: teacherActivityData[0].masterDataId,
                                                            transferKey: "SCHOOL_TEACHER_TRANSFER_KEY",
                                                            alternateBoard: teacherActivityData[0].board,
                                                            ...metaInfo
                                                        };

                                                        dbHelper.updateBulkData(Constants.USER_HOMEWORK_ELO_ACTIVITY_STORE, [eloActivityPayload]).then((err, status) => {

                                                            // let questionSet = questionsByCategory['M1'];
                                                            let questionSet = questions

                                                            let questionSetQuestions = []
                                                            questionSetQuestions = questionSet
                                                            // Order the Questions as ther Order in the Elo Collection homeworkQuestions order or assessment order

                                                            let questionSetQuestionsHash = {}

                                                            questionSetQuestions.forEach(question => questionSetQuestionsHash[question._id.toString()] = question)

                                                            let orderedQuestionSetQuestions = []

                                                            let eloObjectDetails = eloDetails[0]

                                                            if (eloObjectDetails.objects.homeworkQuestions && eloObjectDetails.objects.homeworkQuestions.length) {

                                                                eloObjectDetails.objects.homeworkQuestions.map((content) => {
                                                                    if (content.status) {
                                                                        let contentDetails = questionSetQuestionsHash[content.contentId]
                                                                        if (contentDetails) {
                                                                            orderedQuestionSetQuestions.push(contentDetails)
                                                                        }

                                                                    }
                                                                });
                                                            }


                                                            eloObjectDetails.objects.assessment.map((content) => {
                                                                let contentDetails = questionSetQuestionsHash[content.contentId]
                                                                if (contentDetails) {

                                                                    if (contentDetails.content.competency && contentDetails.content.competency.id === 'YES' && metaInfo.showTimer) {

                                                                        if (eloObjectDetails.skill.id === '5e71cb60e6a6150727ddc846') { // Knowledge
                                                                            contentDetails.content.duration = '1'
                                                                        } else if (eloObjectDetails.skill.id === '5e71cb60e6a6150727ddc848') { // Calculation
                                                                            contentDetails.content.duration = '1.5'
                                                                        } else if (eloObjectDetails.skill.id === '5e71cb60e6a6150727ddc849') { // Modelling
                                                                            contentDetails.content.duration = '2'
                                                                        } else if (eloObjectDetails.skill.id === '5e71cb60e6a6150727ddc84a') { // Comprehension
                                                                            contentDetails.content.duration = '2'
                                                                        }


                                                                    } else if (metaInfo.showTimer) {
                                                                        if (eloObjectDetails.skill.id === '5e71cb60e6a6150727ddc846') { // Knowledge
                                                                            contentDetails.content.duration = '1'
                                                                        } else if (eloObjectDetails.skill.id === '5e71cb60e6a6150727ddc848') { // Calculation
                                                                            contentDetails.content.duration = '1'
                                                                        } else if (eloObjectDetails.skill.id === '5e71cb60e6a6150727ddc849') { // Modelling
                                                                            contentDetails.content.duration = '1.5'
                                                                        } else if (eloObjectDetails.skill.id === '5e71cb60e6a6150727ddc84a') { // Comprehension
                                                                            contentDetails.content.duration = '2'
                                                                        }
                                                                    }

                                                                    orderedQuestionSetQuestions.push(contentDetails)
                                                                }
                                                            });
                                                            // }

                                                            if (!orderedQuestionSetQuestions.length) {
                                                                eloObjectDetails.objects.assessment.map((content) => {
                                                                    let contentDetails = questionSetQuestionsHash[content.contentId]
                                                                    if (contentDetails) {
                                                                        orderedQuestionSetQuestions.push(contentDetails)
                                                                    }
                                                                });
                                                            }

                                                            let response = this.getAssessmentContentResponse(orderedQuestionSetQuestions);
                                                            response.content.map((q) => {
                                                                q['eloId'] = elo["_id"].toString();
                                                                q['categoryThemeId'] = elo["categoryThemeId"];
                                                                q['details']['eloTitle'] = elo['title']
                                                                q['details']['videoUrl'] = videoContentUrl
                                                            });
                                                            let position = this.getEloPosition(nodeActivity, elo["_id"].toString());
                                                            response = {
                                                                ...response,
                                                                ...position
                                                            }

                                                            dbHelper.getAllFromIndex(Constants.USER_HOMEWORK_ELO_ACTIVITY_STORE, 'homeworkId', homeworkId).then((eloActivityData) => {
                                                                let completedQuestionNumber = 0

                                                                // console.log(eloActivityData)

                                                                eloActivityData = eloActivityData.filter(item => item.userId === teacherUserId)

                                                                if (eloActivityData && eloActivityData.length) {

                                                                    eloActivityData.forEach(activity => {
                                                                        if (Object.keys(activity.answers).length) {
                                                                            completedQuestionNumber += Object.keys(activity.answers).length
                                                                        }
                                                                    })
                                                                }

                                                                // console.log(completedQuestionNumber)

                                                                response['completedQuestionNumber'] = completedQuestionNumber

                                                                // Responder.sendResponse(StatusCode.SUCCESS, response, res, req);
                                                                console.log(response)
                                                                callback && callback(null, response);


                                                                // Create the Activity for all the Clicker Users

                                                                let homeworkNodeActivityInsertPayload = [],
                                                                    eloActivityPayload = [], userHomeworkActivityUpdatePayload = []

                                                                for (let i = 0; i < usersList.length; i++) {
                                                                    let user = usersList[i]
                                                                    let userIdNodeIdHomeworkId = user.userId + nodeId + homeworkId
                                                                    let nodeActivity = {
                                                                        userIdNodeIdHomeworkId,
                                                                        userIdHomeworkId: user.userId + homeworkId,
                                                                        nodeId: nodes[0]['_id'].toString(),
                                                                        userId: user.userId,
                                                                        homeworkId,
                                                                        primaryNode: nodes[0],
                                                                        totalAttempts: 1,
                                                                        status: "IN_PROGRESS",
                                                                        createdDate: new Date(),
                                                                        resume: {
                                                                            type: 'ASSESSMENT',
                                                                            eloId: nodes[0].elos[0].id,
                                                                            contentId: null,
                                                                            node: nodes[0],
                                                                            nodeType: 'NORMAL'
                                                                        },
                                                                        board: teacherActivityData[0].board,
                                                                        class: teacherActivityData[0].class,
                                                                        masterDataId: teacherActivityData[0].masterDataId,
                                                                        transferKey: user.transferKey, // Need to Update
                                                                        ...metaInfo
                                                                    };

                                                                    homeworkNodeActivityInsertPayload.push(nodeActivity)

                                                                    let eloActivityObject = {
                                                                        userIdNodeIdHomeworkId,
                                                                        nodeId: nodeActivity.nodeId,
                                                                        questionCategory: 'M11',
                                                                        eloId: elo["_id"].toString(),
                                                                        attemptNumber: 1,
                                                                        answers: {},
                                                                        type: "PRIMARY",
                                                                        status: "IN_PROGRESS",
                                                                        createdDate: new Date(),
                                                                        homeworkId: nodeActivity.homeworkId,
                                                                        userId: user.userId,
                                                                        class: teacherActivityData[0].class,
                                                                        schoolId: teacherActivityData[0].schoolId,
                                                                        // school: teacherActivityData[0].schoolName,
                                                                        board: teacherActivityData[0].board,
                                                                        // boardId: teacherActivityData[0].boardId,
                                                                        section: teacherActivityData[0].section,
                                                                        masterDataId: teacherActivityData[0].masterDataId,
                                                                        transferKey: user.transferKey,
                                                                        ...metaInfo
                                                                    };

                                                                    eloActivityPayload.push(eloActivityObject)


                                                                }

                                                                dbHelper.updateBulkData(Constants.USER_HOMEWORK_NODE_ACTIVITY_STORE, homeworkNodeActivityInsertPayload).then((insertedHomeworkNodes) => {

                                                                    dbHelper.updateBulkData(Constants.USER_HOMEWORK_ELO_ACTIVITY_STORE, eloActivityPayload).then((insertedHomeworkEloActivity) => {
                                                                        console.log('updated User Data')
                                                                    })
                                                                })
                                                            });
                                                        })

                                                    }
                                                    else {
                                                        // Responder.sendResponse(StatusCode.INVALID_DATA, { message: "No Question Category found." }, res, req);
                                                        console.log('No Question Category found.')
                                                        alert('No Question Category found.')
                                                        return;
                                                    }
                                                });
                                            })
                                        })
                                    });
                                })
                            })
                        }
                        else {
                            console.log('homework node not found.')
                            alert('homework node not found.')
                            // Responder.sendResponse(StatusCode.INVALID_DATA, { message: "homework node not found." }, res, req);
                            return;
                        }

                    })


                }
                else {
                    nodeActivities = [nodeActivities]
                    let nodeActivity = nodeActivities[0];
                    console.log(nodeActivity, 'resume flow.........')
                    this.resumeFlow(nodeActivity, metaInfo, contentsHash, assessmentQuestionType, callback);
                }

            })
        }).catch(err => {
            console.log(err)
        })
    }

    createNodeActivity(teacherUserId, node, homeworkId, metaInfo) {

        let nodeActivity = {
            userIdNodeIdHomeworkId: teacherUserId + node['_id'] + homeworkId,
            nodeId: node['_id'].toString(),
            userId: teacherUserId,
            homeworkId,
            primaryNode: node,
            totalAttempts: 1,
            status: "IN_PROGRESS",
            createdDate: new Date(),
            resume: {
                type: 'ASSESSMENT',
                eloId: node.elos[0].id,
                contentId: null,
                node: node,
                nodeType: 'NORMAL'
            },
            transferKey: "SCHOOL_TEACHER_TRANSFER_KEY",
            // ...Utils.getAcademicMetaInformation(req),
            ...metaInfo
        };

        return [nodeActivity];
    }


    prepareQueryForAssessmentContent(eloDetails) {
        let query = {}
        let contentIdList = eloDetails.objects.assessment.map((content) => content.contentId);

        // if (eloDetails.objects.homeworkQuestions && eloDetails.objects.homeworkQuestions.length) {

        //     let noActiveQuestions = false

        //     let c1contentIdList = eloDetails.objects.homeworkQuestions.map((content) => {
        //         if (content.status) {
        //             return content.contentId
        //         }
        //     });

        //     if (c1contentIdList.length) {
        //         contentIdList = [...contentIdList, ...c1contentIdList]
        //     }

        // }

        return contentIdList;
    }

    prepareQueryForAssessmentMetadata(eloDetails) {
        let query = {}
        let contentIdList = eloDetails.objects.assessment.map((content) => content.metaDataId);
        // if (eloDetails.objects.homeworkQuestions && eloDetails.objects.homeworkQuestions.length) {
        //     let noActiveQuestions = false
        //     let c1contentIdList = eloDetails.objects.homeworkQuestions.map((content) => {

        //         if (content.status) {
        //             return content.metaDataId
        //         }

        //     })

        //     if (c1contentIdList.length) {
        //         contentIdList = [...contentIdList, ...c1contentIdList]
        //     }

        // }
        return contentIdList;
    }

    groupByQuestionCategory(questions, questionsMetas, homeworkId) {

        let groupByCategoryQuestions = {};
        let metaHashAgainstQuestionId = {};

        questionsMetas.map((m) => {
            metaHashAgainstQuestionId[m.objectId] = m;
        });

        questions.map((q) => {

            let meta = metaHashAgainstQuestionId[q['_id']];
            if (meta.questionType === 'ADVANCED' && homeworkId === '671f3dc685c9a6272ae24787') {
                if (groupByCategoryQuestions[meta.questionCategory.title]) {
                    groupByCategoryQuestions[meta.questionCategory.title].push(q);
                }
                else {
                    groupByCategoryQuestions[meta.questionCategory.title] = [];
                    groupByCategoryQuestions[meta.questionCategory.title].push(q);
                }
            } else if (homeworkId != '671f3dc685c9a6272ae24787') {
                if (groupByCategoryQuestions[meta.questionCategory.title]) {
                    groupByCategoryQuestions[meta.questionCategory.title].push(q);
                }
                else {
                    groupByCategoryQuestions[meta.questionCategory.title] = [];
                    groupByCategoryQuestions[meta.questionCategory.title].push(q);
                }
            }
        });


        // let questionCategory = Object.keys(groupByCategoryQuestions)

        // if (questionCategory.includes('M1')) {
        //     questionCategory = ['M1']
        // }


        return groupByCategoryQuestions;
    }

    getAssessmentContentResponse(questions) {

        let response = {
            content: [
            ],

            contentType: "QUESTION"
        };

        response.content = questions.map((q) => {

            return {
                id: q["_id"],
                details: q,
                answer: null
            };
        })

        return response;
    }

    getEloPosition(nodeActivity, eloId) {

        let index = 0;
        let elos = nodeActivity.resume.node.elos;

        for (let i = 0; i < elos.length; i++) {

            if (elos[i].id == eloId) {
                index = i;
                break;
            }
        }

        let position = {
            eloPosition: index + 1,
            totalElos: nodeActivity.resume.node.elos.length
        }

        return position;
    }


    resumeFlow(nodeActivity, metaInfo, contentsHash, assessmentQuestionType, callback) {

        let eloIds = this.getAllElosTillElo(nodeActivity.resume.eloId, nodeActivity.resume.node.elos, true);

        let eloQuery = { _id: { $in: eloIds } };

        dbHelper.getData(Constants.ELO_STORE, eloIds[0]).then((eloDetails) => {

            console.log(eloDetails)

            eloDetails = [eloDetails]

            let videoContentUrl = ""

            // console.log(videoContentUrl)

            // let eloActivityQuery = getQueryPayloadForELOActivitiesOnResume(nodeActivity, false);

            let userIdNodeIdHomeworkId = nodeActivity.userId + nodeActivity.nodeId + nodeActivity.homeworkId


            dbHelper.getData(Constants.USER_HOMEWORK_ELO_ACTIVITY_STORE, userIdNodeIdHomeworkId).then((eloActivities) => {

                console.log(eloActivities)

                eloActivities = [eloActivities]

                if (eloActivities.length == 0) {
                    // Responder.sendResponse(StatusCode.INVALID_DATA, { message: "No ELO activity found to resume." }, res, req);
                    callback({ message: "No ELO activity found to resume." }, null)
                    return;
                }

                let response = {
                    resume: {
                        contentId: nodeActivity.resume.contentId
                    },
                    content: []
                };

                this.getRightQuestionsForElosNew(nodeActivity.resume.eloId, eloDetails, eloActivities, videoContentUrl, metaInfo, contentsHash, assessmentQuestionType, (err, questionsResumeElo) => {

                    let resumeContents = []

                    if (metaInfo.selectSingleQuestionFromElo) {
                        response.content = questionsResumeElo.questions.slice(0, 1)
                    } else {
                        // response.content = questionsResumeElo.questions;
                        resumeContents = questionsResumeElo.questions;
                    }

                    let position = this.getEloPosition(nodeActivity, nodeActivity.resume.eloId);
                    let eloQuestions = questionsResumeElo.questions

                    response = {
                        ...response,
                        ...position
                    }

                    let homeworkAllEloActivityQuery = {
                        homeworkId: nodeActivity.homeworkId,
                        userId: nodeActivity.userId,
                        transferKey: nodeActivity.transferKey,
                        "attemptNumber": 1,
                        "type": "PRIMARY"
                    }

                    dbHelper.getAllFromIndex(Constants.USER_HOMEWORK_ELO_ACTIVITY_STORE, 'homeworkId', nodeActivity.homeworkId).then((homeworkEloActivityData) => {

                        let homeworkAllEloActivityData = homeworkEloActivityData.filter(item => item.userId === nodeActivity.userId)

                        let completedQuestionNumber = 0, previousContentIds = [], previousEloIds = []

                        homeworkAllEloActivityData.forEach(activity => {
                            if (Object.keys(activity.answers).length) {

                                completedQuestionNumber += Object.keys(activity.answers).length
                                previousEloIds.push(activity.eloId)

                                Object.entries(activity.studentAnswers).forEach(([key, value]) => {
                                    previousContentIds.push(key)
                                })
                            }
                        })

                        dbHelper.getAllByIds(Constants.ELO_STORE, previousEloIds).then((previousEloDetails) => {

                            let previousEloHash = {}

                            if (previousEloDetails.length) {
                                previousEloDetails.map(elo => previousEloHash[elo._id.toString()] = elo)
                            }


                            dbHelper.getAllByIds(Constants.CONTENTS_STORE, previousContentIds).then((contentData) => {
                                let contentHash = {}, contents = []
                                let currentEloId = eloIds.map(elo => elo.toString())

                                let resumentContentsHash = {}

                                resumeContents.forEach(content => resumentContentsHash[content.id] = content)

                                if (contentData.length) {
                                    contentData.map(content => contentHash[content._id.toString()] = content)
                                    homeworkAllEloActivityData.forEach(activity => {
                                        if (Object.keys(activity.answers).length) {
                                            Object.entries(activity.studentAnswers).forEach(([key, value]) => {
                                                let q = contentHash[key]
                                                q.eloTitle = previousEloHash[activity.eloId].title
                                                // q.videoUrl = videoContentUrl
                                                let obj = {
                                                    eloId: previousEloHash[activity.eloId]["_id"].toString(),
                                                    categoryThemeId: previousEloHash[activity.eloId]["categoryThemeId"],
                                                    id: q["_id"],
                                                    details: q,
                                                    answer: value.answer,
                                                    optionsHash: value.optionsHash,
                                                    nodeId: activity.nodeId
                                                }

                                                if (!q.content.type && value.multiStepTimeListHash) {
                                                    obj.multiStepTimeListHash = value.multiStepTimeListHash ? value.multiStepTimeListHash : {}
                                                }

                                                if (!q.content.type && value.caseStudySkillHash) {
                                                    obj.caseStudySkillHash = value.caseStudySkillHash ? value.caseStudySkillHash : {}
                                                }
                                                contents.push(obj)
                                            })
                                        }
                                    })
                                }

                                if (contents.length) {
                                    resumeContents.forEach(content => {   // in a elo with 3 question if your in 2 question, then add the 3rd question
                                        if (!contentHash[content.id]) {
                                            contents.push(resumentContentsHash[content.id])
                                        }
                                    })
                                    response.content = contents
                                } else {
                                    response.content = resumeContents
                                }


                                response['completedQuestionNumber'] = completedQuestionNumber

                                if (response.resume.contentId == null) {
                                    response.resume.contentId = eloQuestions[0].id;
                                }
                                console.log(response)
                                callback(null, response)
                                // Responder.sendResponse(StatusCode.SUCCESS, response, res, req);

                            });
                        });
                    });
                });
            });
        });
    }

    getAllElosTillElo(eloId, elos, isObjectId) {

        let _elos = [];
        let index = -1;
        for (let i = 0; i < elos.length; i++) {

            if (elos[i].id == eloId) {

                index = i;
                break;
            }
        }

        if (index != -1) {
            for (let i = 0; i <= index; i++) {
                if (isObjectId)
                    _elos.push(elos[i].id);
                else
                    _elos.push(elos[i].id)
            }
        }

        return _elos;
    }


    getRightQuestionsForElosNew(resumeEloId, eloDetails, eloActivities, videoContentUrl, metaInfo, contentsHash, assessmentQuestionType, callback) {

        let questionIds = [];
        let metaDataIds = [];

        let filterResumeEloDetails = eloDetails.filter((elo) => elo._id.toString() == resumeEloId);
        let filterResumeEloActivity = eloActivities.filter((elo) => elo.eloId == resumeEloId)

        let resumeEloDetails = filterResumeEloDetails[0];
        let resumeEloActivity = filterResumeEloActivity[0];

        // if (resumeEloDetails.objects.homeworkQuestions && resumeEloDetails.objects.homeworkQuestions.length) {
        //     resumeEloDetails.objects.homeworkQuestions.map((q) => {
        //         if (q.status) {
        //             questionIds.push(q.contentId);
        //             metaDataIds.push(q.metaDataId);
        //         }
        //     });
        // }

        resumeEloDetails.objects.assessment.map((q) => {
            questionIds.push(q.contentId);
            metaDataIds.push(q.metaDataId);
        });

        if (questionIds.length === 0 && metaDataIds.length === 0) {
            resumeEloDetails.objects.assessment.map((q) => {
                questionIds.push(q.contentId);
                metaDataIds.push(q.metaDataId);
            });
        }

        let query = {
            content: { _id: { $in: questionIds } },
            metadata: { _id: { $in: metaDataIds } }
        };

        dbHelper.getAllByIds(Constants.CONTENTS_STORE, questionIds).then((ContentData) => {

            dbHelper.getAllByIds(Constants.CONTENT_META_DATA_STORE, metaDataIds).then((metaDataContents) => {

                let mapAssessmentQuestions = {};

                let assessmentContents = {
                    contents: ContentData,
                    metadata: metaDataContents
                }

                console.log(assessmentContents)


                assessmentContents.contents.map((q) => {
                    mapAssessmentQuestions[q["_id"]] = {
                        content: q
                    };
                });

                assessmentContents.metadata.map((m) => {
                    let obj = mapAssessmentQuestions[m.objectId];
                    if(obj) {
                        obj['meta'] = m;
                    }
                    
                });


                let questionCategory = resumeEloActivity.questionCategory;

                let assessmentDetails = [];

                // if (resumeEloDetails.objects.homeworkQuestions && resumeEloDetails.objects.homeworkQuestions.length) {
                //     resumeEloDetails.objects.homeworkQuestions.map((ass) => {
                //         if (ass.status) {
                //             let content = mapAssessmentQuestions[ass.contentId].content;
                //             let meta = mapAssessmentQuestions[ass.contentId].meta;
                //             // To not show the Type 7 Labeling Questions
                //             if (content.content.type !== 7) {
                //                 assessmentDetails.push(content);
                //             }
                //         }

                //     });
                // }

                resumeEloDetails.objects.assessment.map((ass) => {
                    console.log(ass)

                    if (mapAssessmentQuestions[ass.contentId]) {
                        let content = mapAssessmentQuestions[ass.contentId].content;
                        let meta = mapAssessmentQuestions[ass.contentId].meta;
                        // To not show the Type 7 Labeling Questions // Show only Signle Select Questions from Worksheet masterdata
                        if ((content.content.type === 1 || (content.content.isMultiStep && content.content.practice && content.content.practice.id === 'CASE STUDY'))) {

                            if (metaInfo.showTimer) {
                                if (content.content.competency && content.content.competency.id === 'YES') {
                                    if (resumeEloDetails.skill.id === '5e71cb60e6a6150727ddc846') { // Knowledge
                                        content.content.duration = '1'
                                    } else if (resumeEloDetails.skill.id === '5e71cb60e6a6150727ddc848') { // Calculation
                                        content.content.duration = '1.5'
                                    } else if (resumeEloDetails.skill.id === '5e71cb60e6a6150727ddc849') { // Modelling
                                        content.content.duration = '2'
                                    } else if (resumeEloDetails.skill.id === '5e71cb60e6a6150727ddc84a') { // Comprehension
                                        content.content.duration = '2'
                                    }
                                } else if (metaInfo.showTimer) {
                                    if (resumeEloDetails.skill.id === '5e71cb60e6a6150727ddc846') { // Knowledge
                                        content.content.duration = '1'
                                    } else if (resumeEloDetails.skill.id === '5e71cb60e6a6150727ddc848') { // Calculation
                                        content.content.duration = '1'
                                    } else if (resumeEloDetails.skill.id === '5e71cb60e6a6150727ddc849') { // Modelling
                                        content.content.duration = '1.5'
                                    } else if (resumeEloDetails.skill.id === '5e71cb60e6a6150727ddc84a') { // Comprehension
                                        content.content.duration = '2'
                                    }
                                }
                            }

                            assessmentDetails.push(content);
                        }
                    }
                });


                if (!assessmentDetails.length) {
                    resumeEloDetails.objects.assessment.map((ass) => {

                        let content = mapAssessmentQuestions[ass.contentId].content;
                        let meta = mapAssessmentQuestions[ass.contentId].meta;
                        // To not show the Type 7 Labeling Questions // Show only Signle Selectr Questions from Worksheet masterdata
                        if ((content.content.type === 1 || (content.content.isMultiStep && content.content.practice && content.content.practice.id === 'CASE STUDY'))) {
                            assessmentDetails.push(content);
                        }
                    });
                }

                // To Update the Image in offline

                assessmentDetails.forEach(contentItem => {
                    let content = contentItem.content
                    if (content.images && content.images.length) {
                        content.images.forEach(item => {
                            delete item.imageUrl
                            item.imageUrl = URL.createObjectURL(item.imageBlob)
                        })
                    }

                    if (content.options && content.options.length) {
                        content.options.forEach(option => {
                            if (option.contentTypeName === 'IMAGE' && option.imageBlob) {
                                delete option.content
                                option.content = URL.createObjectURL(option.imageBlob)
                            }
                        })
                    }


                    // For Multi Step

                    if (content.isMultiStep && content.steps && content.steps.length) {
                        content.steps.forEach(stepContentItem => {
                            let stepContent = stepContentItem.content
                            if (stepContent.images && stepContent.images.length) {
                                stepContent.images.forEach(item => {
                                    delete item.imageUrl
                                    item.imageUrl = URL.createObjectURL(item.imageBlob)
                                })
                            }

                            if (stepContent.options && stepContent.options.length) {
                                stepContent.options.forEach(option => {
                                    if (option.contentTypeName === 'IMAGE' && option.imageBlob) {
                                        delete option.content
                                        option.content = URL.createObjectURL(option.imageBlob)
                                    }
                                })
                            }

                        })
                    }

                    // For Summary Solution

                    if (content.solutionSteps.summarySolutionImagesMap) {
                        let imagesMap = content.solutionSteps.summarySolutionImagesMap
                        let html = content.solutionSteps.summarySolution
                        const dom = new DOMParser().parseFromString(html, "text/html");
                        const imgs = dom.querySelectorAll("img");
                        console.log(imgs)
                        imgs.forEach(img => {
                            const src = img.getAttribute("src");
                            // console.log(src)
                            const blob = imagesMap[src]
                            console.log(typeof imagesMap[src]); // must NOT be "string"
                            console.log(blob instanceof Blob);  // must be true
                            console.log(blob.size);
                            // const blobUrl = URL.createObjectURL(blob);
                            img.src = URL.createObjectURL(blob);
                            // img.setAttribute("src", blobUrl);
                        })
                        content.solutionSteps.summarySolution = dom.body.innerHTML;
                    }
                })

                if (assessmentQuestionType === 'SELECTED_ASSESSMENT_QUESTIONS' && contentsHash) {
                    assessmentDetails = assessmentDetails.filter(item => contentsHash[item._id.toString()] === true)
                }


                let filteredQuestions = assessmentDetails.map((q) => {
                    q.eloTitle = eloDetails[0].title
                    q.videoUrl = videoContentUrl
                    let studentAnswers = resumeEloActivity.studentAnswers && resumeEloActivity.studentAnswers[q["_id"]] ? resumeEloActivity.studentAnswers[q["_id"]] : null
                    return {
                        eloId: resumeEloDetails["_id"].toString(),
                        categoryThemeId: resumeEloDetails["categoryThemeId"],
                        id: q["_id"],
                        details: q,
                        // answer: resumeEloActivity.answers[q["_id"]] ? resumeEloActivity.answers[q["_id"]] : null
                        answer: studentAnswers ? studentAnswers.answer : null,
                        optionsHash: studentAnswers ? studentAnswers.optionsHash : null
                    }
                });

                let questionsByElo = {
                    eloId: resumeEloDetails["_id"].toString(),
                    questions: filteredQuestions
                };

                console.log(questionsByElo)

                callback(null, questionsByElo);

            });
        }).catch(err => {
            console.log('getRightQuestionsForElosNew Error', err)
        })
    }

    setQuestion = (data) => {

        // console.log(CommonUtils.shuffleArray(JSON.parse(JSON.stringify(data.content))))

        console.log(JSON.parse(JSON.stringify(data.content)))


        this.totalElos = data.totalElos;
        this.eloPosition = data.eloPosition;

        // this.setState({ questions: CommonUtils.shuffleArray(JSON.parse(JSON.stringify(data.content))), index: 0, currentQuestionNumber: data.completedQuestionNumber + 1, totalQuestions: this.params.homework.approximateQuestions });

        this.setState({
            questions: JSON.parse(JSON.stringify(data.content)),
            index: 0,
            currentIndex: 0,
            currentQuestionNumber: data.completedQuestionNumber + 1 <= this.params.homework.approximateQuestions ? data.completedQuestionNumber + 1 : data.completedQuestionNumber,
            totalQuestions: this.params.homework.approximateQuestions
        });

        if (data.resume && data.resume.contentId) {

            let resumeIndex = 0;

            for (let i = 0; i < data.content.length; i++) {
                // if (data.content[i].id === data.resume.contentId) { // to To Resume at where we left commented on 17.03.2025
                if (!data.content[i].answer) {
                    resumeIndex = i;
                    break;
                }
            }

            console.log(resumeIndex)

            if (data.content[resumeIndex].details.content.isMultiStep) {

                // console.log(data.content[resumeIndex].answer)

                let stepIndex = 0

                if (data.content[resumeIndex].details.content.steps &&
                    data.content[resumeIndex].details.content.steps.length &&
                    data.content[resumeIndex].answer &&
                    data.content[resumeIndex].answer.answer &&
                    data.content[resumeIndex].answer.answer.steps.length) {
                    stepIndex = data.content[resumeIndex].details.content.steps.length <= data.content[resumeIndex].answer.answer.steps.length ? data.content[resumeIndex].answer.answer.steps.length - 1 : data.content[resumeIndex].answer.answer.steps.length
                }

                this.answer = data.content[resumeIndex].answer

                this.setState({
                    index: resumeIndex,
                    currentIndex: resumeIndex,
                    currentStepIndex: stepIndex,
                    stepIndex: stepIndex,
                    showMainQuestion: stepIndex ? true : false,
                    currentQuestionNumber: stepIndex ? this.state.currentQuestionNumber - 1 : this.state.currentQuestionNumber,
                    // stepIndex: data.content[resumeIndex].answer &&
                    //     data.content[resumeIndex].answer.steps.length ? data.content[resumeIndex].answer.steps.length : 0,
                    questionLoading: false,
                    isResume: true
                }, () => {
                    this.setState({ questionLoading: true })
                });

            } else {
                this.setState({ index: resumeIndex, currentIndex: resumeIndex, isResume: true, questionLoading: false }, () => {
                    this.setState({ questionLoading: true })
                });
            }
        }
    }

    reset = () => {
        this.setState({
            questions: [],
            answers: [],
            learningElos: [],
            index: 0
        });
    }

    next() {

        // console.log(this.answer)

        this.answer = this.questionComponent && this.questionComponent.getAnswer();
        this.optionsHash = this.questionComponent && this.questionComponent.getOptionsInfo()
        this.question = this.state.questions[this.state.index].details;
        // this.state.questions[this.state.index]['answer'] = this.answer
        // console.log(this.question, this.answer, this.optionsHash)
        console.log(this.answer)

        if (this.answer != null && this.state.index >= this.state.currentIndex && !this.state.showPreviousQuestion) {

            let questions = this.state.questions
            questions[this.state.index]['answer'] = this.answer
            // this.state.questions[this.state.index]['answer'] = this.answer
            questions[this.state.index]['optionsHash'] = this.optionsHash
            this.setState({ questions, showPreviousQuestion: false, isResume: false, questionLoading: false })

            if (this.question.content.isMultiStep) {

                console.log('inside multi step')

                let ques = this.question.content.steps[this.state.stepIndex];
                let ans = this.answer.answer.steps[this.state.stepIndex];

                this.setState({ disableNext: true })

                this.setState({ disableNext: false })

                // if (res.data.isCorrect) {
                if (this.question.content.isMultiStep && this.state.stepIndex === this.question.content.steps.length - 1) {

                    if (this.state.questions.length > this.state.index + 1) {
                        this.updateUserActivity(this.state.questions[this.state.index], this.state.questions[this.state.index + 1], this.answer, null, this.optionsHash, (err, updatedResponse) => {
                            if (err) {
                                return
                            }
                            console.log('All Steps Completed', updatedResponse)
                            this.multiStepTimeListHash = updatedResponse.data.timeListHash
                            questions[this.state.index]['multiStepTimeListHash'] = updatedResponse.data.timeListHash
                            questions[this.state.index]['caseStudySkillHash'] = updatedResponse.data.caseStudySkillHash

                            this.setState({ questions })
                            this.ShowCorrectIncorrectModel(false);
                        })

                    } else {

                        // if (this.state.questions[this.state.index] && this.answer) {
                        //     console.log('inside---111')
                        //     if (this.state.questions[this.state.index].id != this.answer.id) {
                        //         console.log('inside---112')
                        //         return
                        //     }
                        // }

                        // console.log('elo end reached to update in next function')

                        this.updateUserActivity(this.state.questions[this.state.index], null, this.answer, null, this.optionsHash, (err, updatedResponse) => {

                            if (err) {
                                return;
                            }

                            console.log(updatedResponse)

                            this.multiStepTimeListHash = updatedResponse.timeListHash
                            questions[this.state.index]['multiStepTimeListHash'] = updatedResponse.timeListHash
                            questions[this.state.index]['caseStudySkillHash'] = updatedResponse.caseStudySkillHash
                            this.setState({ questions })
                            this.assessNode((err, assessdResponse) => {
                                if (err) {
                                    this.setState({ disableNext: false })
                                    return;
                                }

                                let { currentNode, nextNode, isLastNode } = this.getNodeMetaInfo()

                                if (!isLastNode && nextNode) {

                                } else {
                                    console.log("show success failure screen")
                                    // this.showSuccessFailureScreen(res);
                                    this.assessedResponse = assessdResponse
                                }


                                // if (res.data.isCorrect)
                                //     this.ShowCorrectIncorrectModel(true);
                                // else
                                this.ShowCorrectIncorrectModel(false);

                            })
                        })
                    }

                } else {
                    // console.log(this.answer)
                    this.updateUserActivity(this.state.questions[this.state.index], this.state.questions[this.state.index], this.answer, null, this.optionsHash, (err, res) => {
                        if (err) {
                            return
                        }
                        this.nextContinue(this.question, this.answer, false);
                    })
                }
                // this.ShowCorrectIncorrectModel(false);


            } else {

                this.setState({ disableNext: true })
                // this.validateAnswer(this.question, this.answer, (err, res) => {

                //     if (err) {
                //         this.setState({ disableNext: false })
                //         return;
                //     }
                this.setState({ disableNext: false })

                //console.log(res)

                if (this.state.questions.length > this.state.index + 1) {

                    if (this.state.questions[this.state.index] && this.answer) {
                        if (this.state.questions[this.state.index].id != this.answer.id) {
                            return
                        }
                    }

                    this.updateUserActivity(this.state.questions[this.state.index],
                        this.state.questions[this.state.index + 1], this.answer, null, this.optionsHash, (err, updatedRes) => {
                            if (err) {
                                return
                            }
                            // if (res.data.isCorrect)
                            //     this.ShowCorrectIncorrectModel(true);
                            // else
                            this.ShowCorrectIncorrectModel(false);

                        })
                } else {

                    if (this.state.questions[this.state.index] && this.answer) {
                        console.log('inside---111')
                        if (this.state.questions[this.state.index].id != this.answer.id) {
                            console.log('inside---112')
                            return
                        }
                    }

                    this.updateUserActivity(this.state.questions[this.state.index], null, this.answer, null, this.optionsHash, (err, updatedRes) => {

                        if (err) {
                            return;
                        }

                        this.assessNode((err, assessdResponse) => {
                            if (err) {
                                this.setState({ disableNext: false })
                                return;
                            }

                            let { currentNode, nextNode, isLastNode } = this.getNodeMetaInfo()

                            if (!isLastNode && nextNode) {

                            } else {
                                console.log("show success failure screen")
                                // this.showSuccessFailureScreen(res);
                                this.assessedResponse = assessdResponse
                            }

                            // if (res.data.isCorrect)
                            //     this.ShowCorrectIncorrectModel(true);
                            // else

                            console.log('inside next node first question')

                            this.ShowCorrectIncorrectModel(false);

                        })
                    })
                }
                // });
            }
        } else if (this.state.showPreviousQuestion && this.state.index <= this.state.currentIndex) {
            // To See the Prvious Question
            this.answer = this.state.questions[this.state.index].answer
            this.optionsHash = this.state.questions[this.state.index].optionsHash
            console.log('Previous Questions Student Response Screen', this.state.index, this.state.currentIndex, this.answer)

            if (this.question.content.isMultiStep) {
                this.multiStepTimeListHash = this.state.questions[this.state.index].multiStepTimeListHash
                if (this.question.content.steps.length - 1 === this.state.stepIndex) {
                    if (this.state.stepIndex)
                        this.resetStepIndex();

                    this.ShowCorrectIncorrectModel(false);
                } else {

                    this.nextContinue(this.question, this.answer, false)
                }
            } else {
                this.ShowCorrectIncorrectModel(false);
            }

            // this.toggleInvalidAnswerModal(true);
        } else {
            this.setState({ showPreviousQuestion: false })
            console.log('Correct incorrect modal', this.state.index, this.state.currentIndex, this.answer)
            this.toggleInvalidAnswerModal(true);
        }
    }

    nextQuestionOnCorrectInCorrectAnswer() {

        this.setState({ showCorrectIncorrectModal: false, isReadOnly: false, questionLoading: false });

        if (this.question.content.isMultiStep) {
            //console.log('continue 200', this.question)
            if (this.isCorrect)
                this.nextContinue(this.question, this.answer, true);
            else
                this.nextContinue(this.question, this.answer, true);

        } else {
            //console.log('normal next continue called...')
            this.nextContinue(this.question, this.answer);
        }

    }

    nextContinue = (question, answer, branchQuesExit) => {

        if (this.state.questions.length > this.state.index) {

            // let questions = this.state.questions
            // questions[this.state.index]['answer'] = this.answer
            // // this.state.questions[this.state.index]['answer'] = this.answer
            // questions[this.state.index]['optionsHash'] = this.optionsHash
            // this.setState({ questions })
        }


        if (question.content.isMultiStep && question.content.steps.length - 1 > this.state.stepIndex && !branchQuesExit) { /** If question is multi step  */

            let studentList = this.props.studentList

            studentList.forEach(item => {
                item.receivedAnswer = false
                item.isCorrect = null
                item.answerId = ''
            })

            if (this.state.stepIndex + 1 === this.state.currentStepIndex && this.state.index === this.state.currentIndex) {
                this.setState({ showPreviousQuestion: false, showMainQuestion: true })
            }


            this.setState({ stepIndex: this.state.stepIndex + 1, studentList, questionLoading: false }, () => {
                this.setState({ questionLoading: true })
            });


        } else { /** If it normal question */

            console.log("inside normal next question", this.state.questions.length, this.state.index)

            if (this.state.stepIndex)
                this.resetStepIndex();

            if (this.state.questions.length > this.state.index + 1) {
                // if (this.state.questions[this.state.index] && answer) {
                //     if (this.state.questions[this.state.index].id != answer.id) {
                //         return
                //     }
                // }
                console.log('inside Next Question')
                // this.updateUserActivity(this.state.questions[this.state.index], this.state.questions[this.state.index + 1], answer, null, (err, res) => {
                //     if (err) {
                //         return
                //     }

                let studentList = this.props.studentList

                studentList.forEach(item => {
                    item.receivedAnswer = false
                    item.answerId = ''
                })

                this.setState({
                    index: this.state.index + 1,
                    // showPreviousQuestion: false,
                    showPreviousQuestion: this.state.index + 1 === this.state.currentIndex ? false : this.state.index < this.state.currentIndex ? true : this.state.showPreviousQuestion ? true : false,
                    currentQuestionNumber: this.state.currentQuestionNumber + 1, studentList, questionLoading: false
                }, () => {
                    this.setState({ questionLoading: true })
                });
                // });
            }
            else { /** If end of the elo reached */

                console.log("ELO End Reached")


                // if (this.state.questions[this.state.index] && answer) {
                //     console.log('inside---111')
                //     if (this.state.questions[this.state.index].id != answer.id) {
                //         console.log('inside---112')
                //         return
                //     }
                // }

                // this.updateUserActivity(this.state.questions[this.state.index], null, answer, null, (err, res) => {

                //     if (err) {
                //         return;
                //     }

                this.setState({ disableNext: true })
                // this.assessNode((err, res) => {

                //     if (err) {
                //         this.setState({ disableNext: false })
                //         return;
                //     }

                let { currentNode, nextNode, isLastNode } = this.getNodeMetaInfo()

                console.log("isLastNode", isLastNode)
                console.log("Next Node", nextNode)

                if (!isLastNode && nextNode) {

                    this.params.nodeId = nextNode.id

                    this.getAssessmentContent((err, data) => {

                        if (err) {
                            this.setState({ disableNext: false })
                            return;
                        }

                        let studentList = this.props.studentList

                        studentList.forEach(item => {
                            item.receivedAnswer = false
                            item.answerId = ''
                        })

                        this.setState({
                            disableNext: false,
                            // questions: data.content,
                            // index: 0,
                            questions: this.state.questions.concat(data.content),
                            index: this.state.index + 1,
                            // showPreviousQuestion: false,
                            showPreviousQuestion: this.state.index + 1 === this.state.currentIndex ? false : this.state.index < this.state.currentIndex ? true : this.state.showPreviousQuestion ? true : false,
                            // currentIndex: this.state.currentIndex + 1,
                            stepIndex: 0,
                            questionLoading: false,
                            currentQuestionNumber: data.completedQuestionNumber + 1,
                            studentList
                        }, () => {
                            this.setState({ questionLoading: true })
                        });
                    });
                } else {
                    console.log("show success failure screen")
                    this.showSuccessFailureScreen(this.assessedResponse);
                }
                // });

                // });
            }
        }
    }

    assessNode(callback) {

        console.log('inside assess node')

        let payload = {
            nodeId: this.params.nodeId,
            homeworkId: this.params.homeworkId
        }

        let req = {
            body: { ...payload }
        }

        // let userId = reqDetails.userId ? reqDetails.userId : '';
        let nodeId = req.body.nodeId ? req.body.nodeId : '';
        // let transferKey = req.profile.transferKey;
        // let experienceFilter = buildExperienceFilter(metaInfo);

        let homeworkId = req.body.homeworkId;

        // let boardId = reqDetails.boardId ? reqDetails.boardId : '';

        let userIds = [], userIdNodeIdHomeworkIdList = [], teacherUserId = ''

        this.props.studentList.map(item => {
            if (!item.isTeacher) {
                userIds.push(item.userId)

                let id = item.userId + payload.nodeId + payload.homeworkId

                userIdNodeIdHomeworkIdList.push(id)

            } else {
                teacherUserId = item.userId
                let id = item.userId + payload.nodeId + payload.homeworkId
                userIdNodeIdHomeworkIdList.push(id)
            }
        })

        console.log(userIdNodeIdHomeworkIdList)

        dbHelper.getAllByIds(Constants.USER_HOMEWORK_NODE_ACTIVITY_STORE, userIdNodeIdHomeworkIdList).then(nodeActivityResponse => {
            console.log(nodeActivityResponse)
            if (nodeActivityResponse.length === 0) {
                // sendCustomErrorResponse('Couldn\'t find any node activity for given node Id.', res, req)
                console.log('Couldn\'t find any node activity for given node Id.');
                alert('Couldn\'t find any node activity for given node Id.');
                return;
            }

            let nodeActivity = nodeActivityResponse[0];

            if (nodeActivity.resume && nodeActivity.resume.node &&
                nodeActivity.resume.node.elos && nodeActivity.resume.node.elos.length > 0) {

                let eloIdList = [];

                try {
                    nodeActivity.resume.node.elos.map(eloObj => {
                        eloIdList.push(eloObj["id"])
                    });
                } catch (err) {
                    console.log('Found invalid elo Id.');
                    alert('Found invalid elo Id.');
                    return;
                }
                let nodeType = nodeActivity.resume.nodeType;

                dbHelper.getAllByIds(Constants.ELO_STORE, eloIdList).then((eloDetails) => {
                    console.log(eloDetails)
                    let contentIdList = [];
                    let eloThresholdMapping = {};
                    let eloDetailsHash = {};
                    let questionMetaMapping = {};

                    console.log(eloDetails)

                    eloDetails.map((eloObj) => {

                        eloThresholdMapping[eloObj['_id']] = eloObj['threshold'];
                        //elo PK
                        eloDetailsHash[eloObj['_id']] = eloObj;

                        if (eloObj.objects && eloObj.objects.assessment) {

                            eloObj.objects.assessment.map(content => {

                                try {
                                    contentIdList.push((content['contentId']));

                                    // Will be used when aswered wrongly
                                    questionMetaMapping[content['contentId']] = (content['metaDataId']);
                                } catch (e) {
                                    console.log('Found invalid content Id.');
                                    alert('Found invalid content Id.');
                                    return;
                                }
                            })
                        }

                        // if (eloObj.objects.homeworkQuestions && eloObj.objects.homeworkQuestions.length) {

                        //     let noActiveQuestions = false

                        //     let c1contentIdList = eloObj.objects.homeworkQuestions.map((content) => {
                        //         if (content.status) {
                        //             return content.contentId
                        //         }
                        //     });

                        //     if (c1contentIdList.length) {
                        //         contentIdList.push(...c1contentIdList)
                        //     }

                        // }
                    });

                    if (contentIdList.length === 0) {

                        // sendCustomErrorResponse('Couldn\'t find any content Ids for given node Id.', res, req)
                        console.log('Couldn\'t find any content Ids for given node Id.');
                        alert('Couldn\'t find any content Ids for given node Id.');
                        return;
                    }

                    eloIdList.map((id, i) => { eloIdList[i] = String(eloIdList[i]) });

                    let attemptNumber = nodeActivity.totalAttempts;

                    dbHelper.getAllByIds(Constants.USER_HOMEWORK_ELO_ACTIVITY_STORE, userIdNodeIdHomeworkIdList).then((eloActivity) => {

                        console.log(eloActivity)

                        if (eloActivity.length === 0) {
                            console.log('Couldn\'t find any elo activity documents for given node Id.');
                            alert('Couldn\'t find any elo activity documents for given node Id.');
                            // sendCustomErrorResponse('Couldn\'t find any elo activity documents for given node Id.', res, req)
                            return;
                        }

                        let parallelQuestionSet = []

                        eloActivity.map((elo) => {
                            if (elo.isParallelSet) {
                                parallelQuestionSet.push(...elo.questionsToPresent);
                            }
                        })

                        let questionList = parallelQuestionSet.map((question) => question.id);

                        let eloActivityUpdateQuery = { nodeId, attemptNumber, homeworkId };

                        contentIdList.push(...questionList)

                        console.log(contentIdList)
                        contentIdList = contentIdList.filter(item => item != undefined)

                        let contentListQuery = { "_id": { "$in": contentIdList } };

                        dbHelper.getAllByIds(Constants.CONTENTS_STORE, contentIdList).then((contentDetails) => {

                            if (contentDetails.length === 0) {
                                console.log('Couldn\'t find any questions for given node Id.');
                                alert('Couldn\'t find any questions for given node Id.');
                                // sendCustomErrorResponse('Couldn\'t find any questions for given node Id.', res, req)
                                return;
                            }

                            let questionDetailsMapping = {};


                            for (let i = 0; i < contentDetails.length; i++) {

                                let questionId = contentDetails[i]._id;
                                questionDetailsMapping[questionId] = contentDetails[i];
                            }

                            this.calculateThreshold(req, req.database, questionDetailsMapping, eloActivity,
                                eloThresholdMapping, eloActivityUpdateQuery, eloIdList,
                                nodeType, questionMetaMapping, eloDetailsHash, nodeActivity, 'boardId', 'metaInfo', 'experienceFilter', nodeActivityResponse)
                                .then((response) => {

                                    let homeworkNodeQuery = {
                                        homeworkId
                                    };

                                    dbHelper.getAllFromIndex(Constants.HOMEWORK_NODES_STORE, 'homeworkId', homeworkId).then((homeworkNodes) => {

                                        if (!homeworkNodes.length) {
                                            // Responder.sendResponse(StatusCode.INVALID_DATA, { message: "Invalid homeworkId" }, res, req);
                                            callback({ message: "Invalid homeworkId" }, null)
                                            return;
                                        }


                                        homeworkNodes = CommonUtils.sortPayload(homeworkNodes)

                                        let marks = 0

                                        if (nodeId == homeworkNodes[homeworkNodes.length - 1]._id.toString()) {

                                            let updateTeacherActivityQuery = {
                                                homeworkId
                                            }

                                            let updateTeacherActivityPayload = {
                                                status: 'COMPLETED'
                                            }

                                            dbHelper.getAllFromIndex(Constants.TEACHER_HOMEWORK_ACTIVITY_STORE, 'homeworkId', homeworkId).then(teacherActivityData => {

                                                teacherActivityData[0].status = 'COMPLETED'
                                                teacherActivityData[0].pendingSync = true

                                                dbHelper.updateBulkData(Constants.TEACHER_HOMEWORK_ACTIVITY_STORE, teacherActivityData).then((updateInfo) => {
                                                    console.log(response)
                                                    callback(null, response)

                                                    // generateChapterAssessmentQuestions(req, homeworkId, (err, practiceQuestionWiseStudentInfo) => {
                                                    //     response.practiceQuestionWiseStudentInfo = practiceQuestionWiseStudentInfo

                                                    //     Responder.sendResponse(StatusCode.SUCCESS, response, res, req);

                                                    // })
                                                })
                                                // addTeacherReward(req, { type: "HOMEWORK_COMPLETION", activityId: homeworkId })
                                                // moengageTracking(req);
                                            })
                                        } else
                                            // Responder.sendResponse(StatusCode.SUCCESS, response, res, req);
                                            callback(null, response)
                                    })
                                }).catch(err => {

                                    // Responder.sendResponse(StatusCode.SERVER_ERROR, { message: err.stack }, res, req);
                                    callback('err', null)

                                });
                        });
                    });
                })
            } else {
                // sendCustomErrorResponse('Found invalid data in node user activity', res, req)
                console.log('Found invalid data in node user activity');
                alert('Found invalid data in node user activity');
                callback('err', null)
            }
        }).catch(err => {
            console.log(err)
        })
    }


    calculateThreshold(req, db, questionDetails, eloActivity, eloThresholdMapping,
        eloActivityUpdateQuery, orderedEloList, nodeType, questionMetaMapping, eloDetailsHash, nodeActivity, boardId, metaInfo, experienceFilter, nodeActivityResponse) {
        console.log('calculate threshould called')
        return new Promise((resolve, reject) => {

            // let clearedElos = [];
            // let notClearedElos = [];
            let userClearedNotClearedEloHash = {}
            let eloActivityQuery = [];
            let failedElos = [];
            let eloWrongAnswerMetaDataIdList = [];
            let isContinue = false;

            let nodeId = eloActivityUpdateQuery['nodeId'];
            // let userId = eloActivityUpdateQuery['userId'];
            let attemptNumber = eloActivityUpdateQuery['attemptNumber'];
            let homeworkId = eloActivityUpdateQuery['homeworkId'];
            // let transferKey = req.profile.transferKey;


            eloActivity.forEach(eloActivity => {

                let eloActivityAnswers = eloActivity.answers;
                let questionIds = Object.keys(eloActivityAnswers);
                let totalQuestions = questionIds.length;
                let notClearedContent = [];
                let clearedElos = [];
                let notClearedElos = [];

                let totalMark = 0;
                let markScored = 0;

                console.log(totalQuestions)

                questionIds.forEach((totalQuestions, j) => {
                    let questionId = questionIds[j];
                    if (eloActivityAnswers[questionId] && eloActivityAnswers[questionId].status == 'IN_CORRECT') {
                        notClearedContent.push(questionId);

                        //will be used to capture knows and dont knows
                        eloWrongAnswerMetaDataIdList.push({
                            contentMetaDataId: questionMetaMapping[questionId], //will contentMetaDataId be type Object
                            eloId: eloActivity.eloId,
                            answer: eloActivityAnswers[questionId]
                        });
                    } else
                        markScored += eloActivityAnswers[questionId] && eloActivityAnswers[questionId].mark ? eloActivityAnswers[questionId].mark : 0

                    totalMark += eloActivityAnswers[questionId] && eloActivityAnswers[questionId].mark ? eloActivityAnswers[questionId].mark : 0;
                })

                let threshold = ((totalQuestions - notClearedContent.length) / totalQuestions) * 100;

                let eloId = eloActivity.eloId;

                let status = '';

                let score = {
                    value: threshold,
                    type: "%",
                    state: ""
                };

                if (threshold >= eloThresholdMapping[eloId].value) {
                    clearedElos.push({
                        id: eloId,
                        title: eloDetailsHash[eloId].title
                    });
                    status = "CLEARED";
                    score.state = "pass"
                } else {

                    notClearedElos.push({
                        id: eloId,
                        title: eloDetailsHash[eloId].title
                    });
                    status = "NOT_CLEARED";
                    score.state = "fail"
                    failedElos.push(eloId);

                }

                userClearedNotClearedEloHash[eloActivity.userId + '_' + eloActivity.transferKey] = { clearedElos, notClearedElos, failedElos }

                let updatedEloActivityPayload = {
                    status,
                    score,
                    lastUpdatedDate: new Date(),
                    totalMark,
                    markScored
                };

                eloActivity.status = status
                eloActivity.score = score
                eloActivity.lastUpdatedDate = new Date()
                eloActivity.totalMark = totalMark
                eloActivity.markScored = markScored

                // let filter = addExperienceFilter({ nodeId, userId, attemptNumber, eloId, homeworkId, transferKey }, experienceFilter);
                // eloActivity = { ...eloActivity, status, score, lastUpdatedDate: new Date(), totalMark, markScored }
            })

            console.log(eloActivity)


            dbHelper.updateBulkData(Constants.USER_HOMEWORK_ELO_ACTIVITY_STORE, eloActivity).then((status) => {

                let nodeActivityQuery = [], updatedNodeActivityReponse = []

                nodeActivityResponse.forEach(nodeActivityItem => {
                    let clearedElos = userClearedNotClearedEloHash[nodeActivityItem.userId + '_' + nodeActivityItem.transferKey].clearedElos
                    let failedElos = userClearedNotClearedEloHash[nodeActivityItem.userId + '_' + nodeActivityItem.transferKey].failedElos
                    let overAllProgressValue = (clearedElos.length / Object.keys(eloThresholdMapping).length) * 100;

                    let progress = {
                        value: overAllProgressValue,
                        type: '%'
                    };
                    let nodeActivityStatus = overAllProgressValue === 100 ? "CLEARED" : "NOT_CLEARED";


                    let orderedFailedList = [];
                    orderedEloList.filter(elo => {
                        if (failedElos.includes(elo)) {
                            orderedFailedList.push({ "id": elo })
                        }
                    });

                    let obj = {
                        ...nodeActivityItem,
                        status: nodeActivityStatus
                    }

                    updatedNodeActivityReponse.push(obj)
                })

                console.log(updatedNodeActivityReponse)

                dbHelper.updateBulkData(Constants.USER_HOMEWORK_NODE_ACTIVITY_STORE, updatedNodeActivityReponse).then((status) => {
                    // return resolve({ progress, cleared: clearedElos, notCleared: notClearedElos })
                    return resolve({
                        progress: {
                            value: 0,
                            type: '%'
                        }, cleared: [], notCleared: []
                    })

                });
            }).catch(err => {
                console.log(err)
            })
        });
    }



    updateUserActivity(presentContent, resumeContent, answer, isReEnforcementCompleted, optionsHash, callback) {

        let payload = {
            nodeId: this.params.nodeId,
            homeworkId: this.params.homeworkId
        };

        if (presentContent)
            payload.eloActivity = { contentId: presentContent.id, answer: answer, eloId: presentContent.eloId, optionsHash }

        if (resumeContent)
            payload.resume = { contentId: resumeContent.id, eloId: resumeContent.eloId };


        if (isReEnforcementCompleted)
            payload.isReEnforcementCompleted = true;


        let userIds = [], teacherUserId = '', userIdNodeIdHomeworkIdList = []

        this.props.studentList.map(item => {
            if (!item.isTeacher) {
                userIds.push(item.userId)

                let id = item.userId + payload.nodeId + payload.homeworkId

                userIdNodeIdHomeworkIdList.push(id)

            } else {
                teacherUserId = item.userId
                let id = item.userId + payload.nodeId + payload.homeworkId
                userIdNodeIdHomeworkIdList.push(id)
            }
        })

        if (userIds.length) {
            payload.userIds = userIds.join(',')
        }

        let req = {
            body: { ...payload }
        }

        let nodeId = req.body.nodeId || "";
        let userId = teacherUserId
        // let transferKey = req.profile.transferKey;
        let homeworkId = req.body.homeworkId

        let resume = req.body.resume;
        let eloActivity = req.body.eloActivity;
        let userAnswerHash = eloActivity.answer.answer
        isReEnforcementCompleted = req.body.isReEnforcementCompleted;

        let userIdNodeIdHomeworkId = teacherUserId + nodeId + homeworkId

        //Update Elo Activity

        if (eloActivity && eloActivity.contentId && eloActivity.eloId) {


            dbHelper.getAllFromIndex(Constants.TEACHER_HOMEWORK_ACTIVITY_STORE, 'homeworkId', homeworkId).then((teacherActivityData) => {

                teacherActivityData[0].studentList = this.props.studentList

                dbHelper.updateBulkData(Constants.TEACHER_HOMEWORK_ACTIVITY_STORE, teacherActivityData).then(updatedTeacherActivity => {


                    dbHelper.getAllByIds(Constants.USER_HOMEWORK_NODE_ACTIVITY_STORE, userIdNodeIdHomeworkIdList).then((response) => {
                        if (!response || !response.length) {
                            // Responder.sendResponse(StatusCode.SERVER_ERROR, { message: "Internal error" }, res, req);
                            console.log('internal Error no node activity found')
                            return;
                        }

                        dbHelper.getAllByIds(Constants.USER_HOMEWORK_ELO_ACTIVITY_STORE, userIdNodeIdHomeworkIdList).then(eloActivityData => {

                            let eloActivityDataHash = {}

                            eloActivityData.forEach(item => eloActivityDataHash[item.userIdNodeIdHomeworkId] = item)

                            dbHelper.getData(Constants.ELO_STORE, eloActivity.eloId).then((eloData) => {

                                dbHelper.getAllFromIndex(Constants.CONTENT_META_DATA_STORE, "objectId", eloActivity.contentId).then(contentMetaData => {

                                    contentMetaData = contentMetaData[0]

                                    dbHelper.getData(Constants.CONTENTS_STORE, eloActivity.contentId).then((content) => {
                                        content = [content]
                                        if (!content.length) {
                                            // Responder.sendResponse(StatusCode.INVALID_DATA, { message: "Invalid contentId" }, res, req);
                                            console.log('no Content Found')
                                            return;
                                        }

                                        content = content[0]

                                        let isFeedback = content.content.isFeedback ? true : false

                                        // let isWrong = Utils.validateAnswer(content, eloActivity.answer)

                                        let nodeActivity = response[0];

                                        let userAnswerHashBySteps = {}, teacherUserIdAnswerHashForMultiStep = {}

                                        if (userAnswerHash.steps && userAnswerHash.steps.length) {
                                            for (let i = 0; i < userAnswerHash.steps.length; i++) {
                                                let stepItem = userAnswerHash.steps[i]
                                                for (let key in stepItem.answer) {
                                                    let answer = stepItem.answer[key]
                                                    if (!userAnswerHashBySteps[key]) {
                                                        userAnswerHashBySteps[key] = {
                                                            answer: {
                                                                id: userAnswerHash.id,
                                                                steps: [{ answer: answer.answer.answer, timeTakenToAnswer: answer.answer.timeTakenToAnswer, isCorrect: answer.answer.isCorrect }],
                                                                userDeviceMacId: answer.answer.userDeviceMacId,
                                                                timeTakenToAnswer: answer.answer.timeTakenToAnswer
                                                            }
                                                        }
                                                    } else {
                                                        userAnswerHashBySteps[key].answer.steps.push({ answer: answer.answer.answer, timeTakenToAnswer: answer.answer.timeTakenToAnswer, isCorrect: answer.answer.isCorrect })
                                                        userAnswerHashBySteps[key].answer.timeTakenToAnswer += answer.answer.timeTakenToAnswer
                                                    }
                                                }

                                                if (!teacherUserIdAnswerHashForMultiStep[teacherUserId]) {
                                                    teacherUserIdAnswerHashForMultiStep[teacherUserId] = {
                                                        answer: {
                                                            id: userAnswerHash.id,
                                                            steps: [{ answer: null, timeTakenToAnswer: 0, isCorrect: false }]
                                                        }
                                                    }
                                                } else {
                                                    teacherUserIdAnswerHashForMultiStep[teacherUserId].answer.steps[i] = { answer: null, timeTakenToAnswer: 0, isCorrect: false }
                                                }
                                            }
                                            userAnswerHash = userAnswerHashBySteps
                                        }


                                        let caseStudySkillHash = {}

                                        if (resume && resume.contentId && resume.eloId) {


                                            let nodeActivities = response, nodeActivityUpdatePayload = [],
                                                eloActivityUpdatePayload = []

                                            let timeListHash = { correct: [], incorrect: [], notattempted: [] }
                                            let teacherIndex = 0

                                            nodeActivities.forEach((nodeActivity, i) => {
                                                let userNodeActivity = nodeActivity
                                                let answer = userAnswerHash[userNodeActivity.userId]
                                                let eloActivityFromHash = eloActivityDataHash[nodeActivity.userIdNodeIdHomeworkId]

                                                // Bulk Update Homework Elo Activity

                                                if (answer && answer.answer) {
                                                    let isWrong = CommonUtils.validateAnswer(content, answer.answer)

                                                    caseStudySkillHash = CommonUtils.validateAnswerForMultiStepForClickerPracticeQuestionAnalyticalReport(content, answer.answer, caseStudySkillHash)

                                                    let mark = 1 // This mark will be changes in future

                                                    let eloActAUpdatePayload = {
                                                        ...eloActivityFromHash,
                                                        isFeedback
                                                    }

                                                    eloActAUpdatePayload["answers"][eloActivity.contentId] = {
                                                        ...answer.answer, status: isWrong ? 'IN_CORRECT' : 'CORRECT', mark,
                                                        countingwellLastUpdateTimestamp: new Date()
                                                    }

                                                    eloActAUpdatePayload.isUserPresent = true

                                                    eloActAUpdatePayload.chapter = {
                                                        key: userNodeActivity.primaryNode.chapterKey,
                                                        "concept": [
                                                            {
                                                                "key": userNodeActivity.primaryNode.conceptKey,
                                                                "elos": [
                                                                    {
                                                                        "id": eloActivity.eloId
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }

                                                    let caseStudySkillWiseInfo = []

                                                    if (eloData.skill && eloData.skill.title === 'Comprehension' && !content.content.type) {
                                                        content.content.steps.forEach((step, index) => {
                                                            step.skill = contentMetaData.steps[index].skill
                                                        })
                                                        caseStudySkillWiseInfo = CommonUtils.validateAnswerForMultiStepForStudentReport(content, answer.answer)
                                                        eloActAUpdatePayload[`caseStudySkill`][content._id.toString()]["caseStudySkillWiseInfo"] = caseStudySkillWiseInfo
                                                    }

                                                    eloActivityUpdatePayload.push(eloActAUpdatePayload)

                                                    if (content.content.isMultiStep) {
                                                        let status = isWrong ? 'IN_CORRECT' : 'CORRECT'

                                                        let timeTakenInMins = (answer.answer.timeTakenToAnswer / 1000).toFixed(3)
                                                        if (status === 'CORRECT') {
                                                            timeListHash['correct'].push({
                                                                userId: userNodeActivity.userId,
                                                                timeTakenInMins,
                                                                timeTakenToAnswer: answer.answer.timeTakenToAnswer,
                                                                status: 'CORRECT'
                                                            })
                                                        } else {
                                                            timeListHash['incorrect'].push({
                                                                userId: userNodeActivity.userId,
                                                                timeTakenInMins,
                                                                timeTakenToAnswer: answer.answer.timeTakenToAnswer,
                                                                status: 'IN_CORRECT'
                                                            })
                                                        }
                                                    }

                                                } else if (teacherUserId === userNodeActivity.userId && content.content.isMultiStep) {
                                                    let isWrong = true

                                                    let mark = 1 // This mark will be changes in future
                                                    teacherIndex = i
                                                    let eloActAUpdatePayload = {
                                                        ...eloActivityFromHash,
                                                        // studentAnswers: {}
                                                    }

                                                    if (!eloActAUpdatePayload.studentAnswers) {
                                                        eloActAUpdatePayload.studentAnswers = {}
                                                    }

                                                    eloActAUpdatePayload["answers"][eloActivity.contentId] = { ...teacherUserIdAnswerHashForMultiStep[teacherUserId].answer, status: isWrong ? 'IN_CORRECT' : 'CORRECT', mark }
                                                    eloActAUpdatePayload["studentAnswers"][eloActivity.contentId] = { answer: eloActivity.answer, optionsHash: eloActivity.optionsHash }

                                                    if (answer && answer.pauseDetails) {
                                                        eloActAUpdatePayload["answers"][eloActivity.contentId] = { ...eloActAUpdatePayload["answers"][eloActivity.contentId], pauseDetails: answer.pauseDetails }
                                                    }

                                                    eloActivityUpdatePayload.push(eloActAUpdatePayload)
                                                } else if (teacherUserId === userNodeActivity.userId) {
                                                    let isWrong = true

                                                    let mark = 1 // This mark will be changes in future

                                                    console.log(eloActivityFromHash)

                                                    let eloActAUpdatePayload = {
                                                        ...eloActivityFromHash,
                                                        // studentAnswers: {}
                                                    }

                                                    if (!eloActAUpdatePayload.studentAnswers) {
                                                        eloActAUpdatePayload.studentAnswers = {}
                                                    }

                                                    eloActAUpdatePayload["answers"][eloActivity.contentId] = { status: isWrong ? 'IN_CORRECT' : 'CORRECT', mark }
                                                    eloActAUpdatePayload["studentAnswers"][eloActivity.contentId] = { answer: eloActivity.answer, optionsHash: eloActivity.optionsHash }

                                                    if (answer && answer.pauseDetails) {
                                                        eloActAUpdatePayload["answers"][eloActivity.contentId] = { ...eloActAUpdatePayload["answers"][eloActivity.contentId], pauseDetails: answer.pauseDetails }
                                                    }

                                                    eloActivityUpdatePayload.push(eloActAUpdatePayload)
                                                } else {
                                                    let isWrong = true

                                                    let mark = 1 // This mark will be changes in future

                                                    let eloActAUpdatePayload = {
                                                        ...eloActivityFromHash
                                                    }

                                                    eloActAUpdatePayload["answers"][eloActivity.contentId] = { status: isWrong ? 'IN_CORRECT' : 'CORRECT', mark }


                                                    if (answer && answer.pauseDetails) {
                                                        eloActAUpdatePayload["answers"][eloActivity.contentId] = { ...eloActAUpdatePayload["answers"][eloActivity.contentId], pauseDetails: answer.pauseDetails }
                                                    }

                                                    eloActivityUpdatePayload.push(eloActAUpdatePayload)
                                                }





                                                // Bulk Update Homework Node Activity

                                                nodeActivity["resume.eloId"] = resume.eloId
                                                nodeActivity["resume.contentId"] = resume.contentId
                                                nodeActivity.countingwellLastUpdateTimestamp = new Date()

                                            })

                                            console.log(eloActivityUpdatePayload, teacherIndex)

                                            if (content.content.isMultiStep) {
                                                eloActivityUpdatePayload[teacherIndex]["studentAnswers"][eloActivity.contentId] = { ...eloActivityUpdatePayload[teacherIndex]["studentAnswers"][eloActivity.contentId], multiStepTimeListHash: timeListHash, caseStudySkillHash }
                                            }




                                            dbHelper.updateBulkData(Constants.USER_HOMEWORK_ELO_ACTIVITY_STORE, eloActivityUpdatePayload).then((responseEloUpdated) => {

                                                dbHelper.updateBulkData(Constants.USER_HOMEWORK_NODE_ACTIVITY_STORE, nodeActivityUpdatePayload).then((responseNodeUpdated) => {

                                                    // Responder.sendResponse(StatusCode.SUCCESS, { message: "User activity updated", timeListHash, caseStudySkillHash }, res, req);
                                                    callback(null, { message: "User activity updated", timeListHash, caseStudySkillHash })
                                                })
                                            });

                                        } else {
                                            // let resumeUpdateQuery = {
                                            //     userId: userId,
                                            //     nodeId: nodeId,
                                            //     homeworkId,
                                            //     transferKey: transferKey,
                                            //     ...filterInfo
                                            // };

                                            let resume = nodeActivity.resume;

                                            if (resume.eloId && resume.node.elos && resume.node.elos.length) {

                                                let currentEloId = resume.eloId;
                                                let elos = resume.node.elos;
                                                let flatElos = elos.map((item) => item.id);
                                                let postionOfElo = flatElos.indexOf(currentEloId);
                                                let eloToUpdate = null;

                                                let timeListHash = { correct: [], incorrect: [], notattempted: [] }
                                                let teacherIndex = 0

                                                if (postionOfElo == flatElos.length - 1) {
                                                    let nodeActivities = response,
                                                        eloActivityUpdatePayload = []

                                                    nodeActivities.forEach((nodeActivity, i) => {
                                                        let userNodeActivity = nodeActivity
                                                        let answer = userAnswerHash[userNodeActivity.userId]
                                                        let eloActivityFromHash = eloActivityDataHash[nodeActivity.userIdNodeIdHomeworkId]

                                                        // Bulk Update Homework Elo Activity

                                                        if (answer && answer.answer) {
                                                            let isWrong = CommonUtils.validateAnswer(content, answer.answer)

                                                            caseStudySkillHash = CommonUtils.validateAnswerForMultiStepForClickerPracticeQuestionAnalyticalReport(content, answer.answer, caseStudySkillHash)

                                                            let mark = 1 // This mark will be changes in future

                                                            let eloActAUpdatePayload = {
                                                                ...eloActivityFromHash,
                                                                isFeedback
                                                            }

                                                            eloActAUpdatePayload["answers"][eloActivity.contentId] = {
                                                                ...answer.answer, status: isWrong ? 'IN_CORRECT' : 'CORRECT', mark,
                                                                countingwellLastUpdateTimestamp: new Date()
                                                            }

                                                            eloActAUpdatePayload.isUserPresent = true
                                                            eloActAUpdatePayload.chapter = {
                                                                key: userNodeActivity.primaryNode.chapterKey,
                                                                "concept": [
                                                                    {
                                                                        "key": userNodeActivity.primaryNode.conceptKey,
                                                                        "elos": [
                                                                            {
                                                                                "id": eloActivity.eloId
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }

                                                            let caseStudySkillWiseInfo = []

                                                            if (eloData.skill && eloData.skill.title === 'Comprehension' && !content.content.type) {
                                                                content.content.steps.forEach((step, index) => {
                                                                    step.skill = contentMetaData.steps[index].skill
                                                                })
                                                                caseStudySkillWiseInfo = CommonUtils.validateAnswerForMultiStepForStudentReport(content, answer.answer)
                                                                eloActAUpdatePayload[`caseStudySkill`][content._id.toString()]["caseStudySkillWiseInfo"] = caseStudySkillWiseInfo
                                                            }


                                                            eloActivityUpdatePayload.push(eloActAUpdatePayload)

                                                            if (content.content.isMultiStep) {
                                                                let status = isWrong ? 'IN_CORRECT' : 'CORRECT'

                                                                let timeTakenInMins = (answer.answer.timeTakenToAnswer / 1000).toFixed(3)
                                                                if (status === 'CORRECT') {
                                                                    timeListHash['correct'].push({
                                                                        userId: userNodeActivity.userId,
                                                                        timeTakenInMins,
                                                                        timeTakenToAnswer: answer.answer.timeTakenToAnswer,
                                                                        status: 'CORRECT'
                                                                    })
                                                                } else {
                                                                    timeListHash['incorrect'].push({
                                                                        userId: userNodeActivity.userId,
                                                                        timeTakenInMins,
                                                                        timeTakenToAnswer: answer.answer.timeTakenToAnswer,
                                                                        status: 'IN_CORRECT'
                                                                    })
                                                                }
                                                            }

                                                        } else if (teacherUserId === userNodeActivity.userId && content.content.isMultiStep) {
                                                            let isWrong = true

                                                            let mark = 1 // This mark will be changes in future
                                                            teacherIndex = i
                                                            let eloActAUpdatePayload = {
                                                                ...eloActivityFromHash
                                                            }

                                                            if (!eloActAUpdatePayload.studentAnswers) {
                                                                eloActAUpdatePayload.studentAnswers = {}
                                                            }

                                                            eloActAUpdatePayload["answers"][eloActivity.contentId] = { ...teacherUserIdAnswerHashForMultiStep[teacherUserId].answer, status: isWrong ? 'IN_CORRECT' : 'CORRECT', mark }
                                                            eloActAUpdatePayload["studentAnswers"][eloActivity.contentId] = { answer: eloActivity.answer, optionsHash: eloActivity.optionsHash }

                                                            if (answer && answer.pauseDetails) {
                                                                eloActAUpdatePayload["answers"][eloActivity.contentId] = { ...eloActAUpdatePayload["answers"][eloActivity.contentId], pauseDetails: answer.pauseDetails }
                                                            }

                                                            eloActivityUpdatePayload.push(eloActAUpdatePayload)
                                                        } else if (teacherUserId === userNodeActivity.userId) {
                                                            let isWrong = true

                                                            let mark = 1 // This mark will be changes in future

                                                            let eloActAUpdatePayload = {
                                                                ...eloActivityFromHash
                                                            }

                                                            if (!eloActAUpdatePayload.studentAnswers) {
                                                                eloActAUpdatePayload.studentAnswers = {}
                                                            }

                                                            eloActAUpdatePayload["answers"][eloActivity.contentId] = { status: isWrong ? 'IN_CORRECT' : 'CORRECT', mark }
                                                            eloActAUpdatePayload["studentAnswers"][eloActivity.contentId] = { answer: eloActivity.answer, optionsHash: eloActivity.optionsHash }

                                                            if (answer && answer.pauseDetails) {
                                                                eloActAUpdatePayload["answers"][eloActivity.contentId] = { ...eloActAUpdatePayload["answers"][eloActivity.contentId], pauseDetails: answer.pauseDetails }
                                                            }

                                                            eloActivityUpdatePayload.push(eloActAUpdatePayload)
                                                        } else {
                                                            let isWrong = true

                                                            let mark = 1 // This mark will be changes in future

                                                            let eloActAUpdatePayload = {
                                                                ...eloActivityFromHash
                                                            }

                                                            eloActAUpdatePayload["answers"][eloActivity.contentId] = { status: isWrong ? 'IN_CORRECT' : 'CORRECT', mark }


                                                            if (answer && answer.pauseDetails) {
                                                                eloActAUpdatePayload["answers"][eloActivity.contentId] = { ...eloActAUpdatePayload["answers"][eloActivity.contentId], pauseDetails: answer.pauseDetails }
                                                            }

                                                            eloActivityUpdatePayload.push(eloActAUpdatePayload)
                                                        }



                                                    })

                                                    console.log(eloActivityUpdatePayload, teacherIndex)

                                                    if (content.content.isMultiStep) {
                                                        eloActivityUpdatePayload[teacherIndex]["studentAnswers"][eloActivity.contentId] = { ...eloActivityUpdatePayload[teacherIndex]["studentAnswers"][eloActivity.contentId], multiStepTimeListHash: timeListHash, caseStudySkillHash }
                                                    }

                                                    dbHelper.updateBulkData(Constants.USER_HOMEWORK_ELO_ACTIVITY_STORE, eloActivityUpdatePayload).then((responseEloUpdated) => {
                                                        // Responder.sendResponse(StatusCode.SUCCESS, { message: "User activity updated", timeListHash, caseStudySkillHash }, res, req);
                                                        callback(null, { message: "User activity updated", timeListHash, caseStudySkillHash })

                                                    });



                                                } else if (postionOfElo < flatElos.length - 1) {
                                                    eloToUpdate = flatElos[postionOfElo + 1];
                                                    if (eloToUpdate) {

                                                        // let nodeActivityPayload = {
                                                        //     ["resume.eloId"]: eloToUpdate,
                                                        //     ["resume.contentId"]: null,
                                                        // }

                                                        let nodeActivities = response, nodeActivityUpdatePayload = [],
                                                            eloActivityUpdatePayload = []



                                                        nodeActivities.forEach((nodeActivity, i) => {
                                                            let userNodeActivity = nodeActivity
                                                            let answer = userAnswerHash[userNodeActivity.userId]
                                                            let eloActivityFromHash = eloActivityDataHash[nodeActivity.userIdNodeIdHomeworkId]

                                                            // Bulk Update Homework Elo Activity

                                                            if (answer && answer.answer) {
                                                                let isWrong = CommonUtils.validateAnswer(content, answer.answer)

                                                                caseStudySkillHash = CommonUtils.validateAnswerForMultiStepForClickerPracticeQuestionAnalyticalReport(content, answer.answer, caseStudySkillHash)

                                                                let mark = 1 // This mark will be changes in future

                                                                let eloActAUpdatePayload = {
                                                                    ...eloActivityFromHash,
                                                                    isFeedback
                                                                }

                                                                eloActAUpdatePayload["answers"][eloActivity.contentId] = {
                                                                    ...answer.answer, status: isWrong ? 'IN_CORRECT' : 'CORRECT', mark,
                                                                    countingwellLastUpdateTimestamp: new Date()
                                                                }

                                                                eloActAUpdatePayload.isUserPresent = true
                                                                eloActAUpdatePayload.chapter = {
                                                                    key: userNodeActivity.primaryNode.chapterKey,
                                                                    "concept": [
                                                                        {
                                                                            "key": userNodeActivity.primaryNode.conceptKey,
                                                                            "elos": [
                                                                                {
                                                                                    "id": eloActivity.eloId
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }

                                                                let caseStudySkillWiseInfo = []

                                                                if (eloData.skill && eloData.skill.title === 'Comprehension' && !content.content.type) {
                                                                    content.content.steps.forEach((step, index) => {
                                                                        step.skill = contentMetaData.steps[index].skill
                                                                    })
                                                                    caseStudySkillWiseInfo = CommonUtils.validateAnswerForMultiStepForStudentReport(content, answer.answer)
                                                                    eloActAUpdatePayload[`caseStudySkill`][content._id.toString()]["caseStudySkillWiseInfo"] = caseStudySkillWiseInfo
                                                                }


                                                                eloActivityUpdatePayload.push(eloActAUpdatePayload)

                                                                if (content.content.isMultiStep) {
                                                                    let status = isWrong ? 'IN_CORRECT' : 'CORRECT'

                                                                    let timeTakenInMins = (answer.answer.timeTakenToAnswer / 1000).toFixed(3)
                                                                    if (status === 'CORRECT') {
                                                                        timeListHash['correct'].push({
                                                                            userId: userNodeActivity.userId,
                                                                            timeTakenInMins,
                                                                            timeTakenToAnswer: answer.answer.timeTakenToAnswer,
                                                                            status: 'CORRECT'
                                                                        })
                                                                    } else {
                                                                        timeListHash['incorrect'].push({
                                                                            userId: userNodeActivity.userId,
                                                                            timeTakenInMins,
                                                                            timeTakenToAnswer: answer.answer.timeTakenToAnswer,
                                                                            status: 'IN_CORRECT'
                                                                        })
                                                                    }
                                                                }

                                                            } else if (teacherUserId === userNodeActivity.userId && content.content.isMultiStep) {
                                                                let isWrong = true

                                                                let mark = 1 // This mark will be changes in future
                                                                teacherIndex = i
                                                                let eloActAUpdatePayload = {
                                                                    ...eloActivityFromHash
                                                                }

                                                                if (!eloActAUpdatePayload.studentAnswers) {
                                                                    eloActAUpdatePayload.studentAnswers = {}
                                                                }


                                                                eloActAUpdatePayload["answers"][eloActivity.contentId] = { ...teacherUserIdAnswerHashForMultiStep[teacherUserId].answer, status: isWrong ? 'IN_CORRECT' : 'CORRECT', mark }
                                                                eloActAUpdatePayload["studentAnswers"][eloActivity.contentId] = { answer: eloActivity.answer, optionsHash: eloActivity.optionsHash }

                                                                if (answer && answer.pauseDetails) {
                                                                    eloActAUpdatePayload["answers"][eloActivity.contentId] = { ...eloActAUpdatePayload["answers"][eloActivity.contentId], pauseDetails: answer.pauseDetails }
                                                                }

                                                                eloActivityUpdatePayload.push(eloActAUpdatePayload)
                                                            } else if (teacherUserId === userNodeActivity.userId) {
                                                                let isWrong = true

                                                                let mark = 1 // This mark will be changes in future

                                                                let eloActAUpdatePayload = {
                                                                    ...eloActivityFromHash
                                                                }

                                                                if (!eloActAUpdatePayload.studentAnswers) {
                                                                    eloActAUpdatePayload.studentAnswers = {}
                                                                }


                                                                eloActAUpdatePayload["answers"][eloActivity.contentId] = { status: isWrong ? 'IN_CORRECT' : 'CORRECT', mark }
                                                                eloActAUpdatePayload["studentAnswers"][eloActivity.contentId] = { answer: eloActivity.answer, optionsHash: eloActivity.optionsHash }

                                                                if (answer && answer.pauseDetails) {
                                                                    eloActAUpdatePayload["answers"][eloActivity.contentId] = { ...eloActAUpdatePayload["answers"][eloActivity.contentId], pauseDetails: answer.pauseDetails }
                                                                }

                                                                eloActivityUpdatePayload.push(eloActAUpdatePayload)
                                                            } else {
                                                                let isWrong = true

                                                                let mark = 1 // This mark will be changes in future

                                                                let eloActAUpdatePayload = {
                                                                    ...eloActivityFromHash
                                                                }

                                                                eloActAUpdatePayload["answers"][eloActivity.contentId] = { status: isWrong ? 'IN_CORRECT' : 'CORRECT', mark }


                                                                if (answer && answer.pauseDetails) {
                                                                    eloActAUpdatePayload["answers"][eloActivity.contentId] = { ...eloActAUpdatePayload["answers"][eloActivity.contentId], pauseDetails: answer.pauseDetails }
                                                                }

                                                                eloActivityUpdatePayload.push(eloActAUpdatePayload)
                                                            }



                                                            // Bulk Update Homework Node Activity

                                                            nodeActivity["resume.eloId"] = resume.eloId
                                                            nodeActivity["resume.contentId"] = resume.contentId
                                                            nodeActivity.countingwellLastUpdateTimestamp = new Date()

                                                        })

                                                        console.log(eloActivityUpdatePayload, teacherIndex)

                                                        if (content.content.isMultiStep) {
                                                            eloActivityUpdatePayload[teacherIndex]["studentAnswers"][eloActivity.contentId] = { ...eloActivityUpdatePayload[teacherIndex]["studentAnswers"][eloActivity.contentId], multiStepTimeListHash: timeListHash, caseStudySkillHash }
                                                        }

                                                        dbHelper.updateBulkData(Constants.USER_HOMEWORK_ELO_ACTIVITY_STORE, eloActivityUpdatePayload).then((responseEloUpdated) => {

                                                            dbHelper.updateBulkData(Constants.USER_HOMEWORK_NODE_ACTIVITY_STORE, nodeActivityUpdatePayload).then((responseNodeUpdated) => {

                                                                // Responder.sendResponse(StatusCode.SUCCESS, { message: "User activity updated", timeListHash, caseStudySkillHash }, res, req);
                                                                callback(null, { message: "User activity updated", timeListHash, caseStudySkillHash })
                                                            })
                                                        });
                                                    } else {
                                                        // Responder.sendResponse(StatusCode.SERVER_ERROR, { message: "Internal error" }, res, req);
                                                        callback({ message: "Internal error" }, null)
                                                    }
                                                }

                                            } else {
                                                // Responder.sendResponse(StatusCode.SERVER_ERROR, { message: "No elo found" }, res, req);
                                                callback({ message: "No elo found" }, null)
                                            }
                                        }
                                        // });
                                    })
                                })
                            })
                        })
                    });
                })
            })
        } else {
            // Responder.sendResponse(ErrorCode.MISSING_PARAMETER, { message: "Missing contentId and eloId" }, res, req);
            callback({ message: "Missing contentId and eloId" }, null)
        }
    }

    showSuccessFailureScreen = (data) => {

        console.log(data)

        // this.layoutShared.toggleSidebar(true)

        this.setState({ disableNext: false })

        this.successFailureScreenData = {
            concepts: this.params.concepts,
            chapterTitle: this.params.title,
            homeworkId: this.params.homeworkId,
            cleared: data.cleared,
            notCleared: data.notCleared,
            progress: data.progress,
            chapterImageUrl: this.params.chapterImageUrl
        }

        this.props.delegate && this.props.delegate.showAssessmentEndScreen && this.props.delegate.showAssessmentEndScreen({
            data: data
            // percentage: (res.data.markScored / res.data.totalMark) * 100,
            // chapterTitle: this.chapterTitle,
            // categoryThemeId: this.categoryThemeId,
            // assessmentActivityId: this.assessmentActivityId,
            // chapterKey: this.chapterKey,
            // type: this.meta.type,
            // eventId: this.meta.eventId,
            // from: this.meta.from,
            // selectedChapters: this.meta.selectedChapters,
            // scholarshipEligibleStaticText: this.meta.scholarshipEligibleStaticText ? this.meta.scholarshipEligibleStaticText : {},
            // eventPayload: this.meta && this.meta.eventPayload ? this.meta.eventPayload : {},
            // isExamPrepKit: this.meta && this.meta.isExamPrepKit ? this.meta.isExamPrepKit : "",
            // isFromMyHomework: this.meta && this.meta.isFromMyHomework,
            // isDueDatePassed: this.meta && this.meta.isDueDatePassed,
            // viewAnswerTime: this.meta && this.meta.viewAnswerTime,
            // from: this.meta.from
        })

        // this.props.delegate && this.props.delegate.showReport && this.props.delegate.showReport("ELO_LEVEL_REPORT", this.params.homework, 0, 0, 'COMPLETION_SCREEN')

        // this.setState({ showSuccessFailureScreen: true }, () => {

        //     // if (!this.userInfo.isSubscribed) {

        //         // AppState.removeEventListener('change', this._handleAppStateChange);

        //         // if (this.landingScreenInstance)
        //         //     this.landingScreenInstance.resumeUserAppTime()

        //         // this.showTimerResumeText()
        //     // }
        // })
    }

    getCurrentNode = () => {
        let nodes = this.params.nodes;
        for (let i = 0; i < nodes.length; i++) {
            if (nodes[i].id == this.params.nodeId) {
                return nodes[i];
            }
        }
    }

    previous(isReadOnly = false) {

        console.log('previous Pressed', isReadOnly)
        let question = this.state.questions[this.state.index].details;
        let studentList = this.props.studentList

        studentList.forEach(item => {
            item.receivedAnswer = false
            item.answerId = ''
        })

        this.setState({ studentList })


        if (isReadOnly === true) {
            console.log('is readonly')
            if (this.state.stepIndex) {
                this.resetStepIndex()
            }

            if (!this.state.showPreviousQuestion) {
                this.setState({
                    currentIndex: this.state.index + 1,
                    showPreviousQuestion: true,
                    questionLoading: false
                }, () => {
                    this.setState({ questionLoading: true })
                });
            } else {
                this.setState({
                    showPreviousQuestion: true,
                    questionLoading: false
                }, () => {
                    this.setState({ questionLoading: true })
                });
            }
            return
        }


        if (question.content.isMultiStep && this.state.stepIndex !== 0) {
            console.log("inside Previous Step", this.state.stepIndex)

            if (!this.state.showPreviousQuestion) {
                this.setState({
                    currentStepIndex: this.state.stepIndex,
                    stepIndex: this.state.stepIndex - 1,
                    currentIndex: this.state.index,
                    showMainQuestion: false,
                    // currentQuestionNumber: this.state.currentQuestionNumber - 1,
                    showPreviousQuestion: true,
                    questionLoading: false
                }, () => {
                    this.setState({ questionLoading: true })
                });
            } else {
                this.setState({
                    stepIndex: this.state.stepIndex - 1,
                    showMainQuestion: this.state.stepIndex - 1 === 0 ? false : true,
                    // index: this.state.index - 1,
                    // currentQuestionNumber: this.state.currentQuestionNumber - 1,
                    showPreviousQuestion: true,
                    questionLoading: false
                }, () => {
                    this.setState({ questionLoading: true })
                });
            }

        } else if (question.content.isMultiStep && this.state.stepIndex === 0 && !this.state.showMainQuestion) {
            this.setState({
                stepIndex: 0,
                showMainQuestion: true,
                // index: this.state.index - 1,
                // currentQuestionNumber: this.state.currentQuestionNumber - 1,
                showPreviousQuestion: true,
                questionLoading: false
            }, () => {
                this.setState({ questionLoading: true })
            });
        }
        // else if (question.content.isMultiStep && this.state.stepIndex === 0 && this.state.showMainQuestion
        //     && !this.state.questions[this.state.index].answer
        // ) {
        //     this.setState({
        //         stepIndex: 0,
        //         showMainQuestion: true,
        //         // index: this.state.index - 1,
        //         // currentQuestionNumber: this.state.currentQuestionNumber - 1,
        //         showPreviousQuestion: true,
        //         questionLoading: false
        //     }, () => {
        //         this.setState({ questionLoading: true })
        //     });
        // }
        else {

            if (this.state.index != 0) {
                console.log('inside Previous')


                if (this.state.stepIndex) {
                    this.resetStepIndex()
                }

                if (!this.state.showPreviousQuestion) {
                    this.setState({
                        currentIndex: this.state.index,
                        index: this.state.index - 1,
                        currentQuestionNumber: this.state.currentQuestionNumber - 1,
                        showPreviousQuestion: true,
                        questionLoading: false
                    }, () => {
                        this.setState({ questionLoading: true })
                    });
                } else {
                    this.setState({
                        index: this.state.index - 1,
                        currentQuestionNumber: this.state.currentQuestionNumber - 1,
                        showPreviousQuestion: true,
                        questionLoading: false
                    }, () => {
                        this.setState({ questionLoading: true })
                    });
                }
            }
        }
    }

    resetStepIndex = () => {
        this.setState({ stepIndex: 0 });
    }

    validateAnswer = (question, answer, callback) => {

        let payload = { question, answer };

        HomeworkForClickerPracticeApi.validateAnswerForClickerPractice(payload).then((res) => {
            callback(null, res);
        }).catch(err => {
            callback(err, null);
        })
    }

    goToChapterList = () => {
        this.props.navigation.navigate('Chapters')
    }

    goToLateralMenu = () => {
        this.props.navigation.navigate('LateralMenu')
    }

    toggleInvalidAnswerModal = (value) => {
        this.setState({ showInvalidAnswerModal: value, questionLoading: true }, () => {
            this.setState({ questionLoading: true })
        });
    }

    ShowCorrectIncorrectModel = (isCorrect) => {
        this.isCorrect = isCorrect;
        this.setState({ showCorrectIncorrectModal: true, questionLoading: false }, () => {
            this.setState({ questionLoading: true })
        })
    }

    hideCorrectIncorrectModal() {
        this.setState({ showCorrectIncorrectModal: false });
    }

    onOk = () => {
        this.toggleInvalidAnswerModal(false);
    }

    getNodeMetaInfo = () => {

        let currentNodeIndex = null

        let nodes = this.params.nodes;

        //console.log(nodes)

        for (let i = 0; i < nodes.length; i++) {
            if (nodes[i].id == this.params.nodeId) {
                currentNodeIndex = i
                break;
            }
        }
        return { currentNode: nodes[currentNodeIndex], nextNode: nodes[currentNodeIndex + 1], isLastNode: nodes.length - 1 <= currentNodeIndex }
    }

    onPressResumeTimePopupContinue = () => {
        this.setState({ showResumeTimePopup: false })
    }

    showTimerPauseToast = () => {
        let minutes = this.getRemainingTime()
        let message = CommonUtils.simpleTemplateEngine(this.staticText.timerPauseText, { time: minutes })
        this.setState({ toastText: message }, () => {
            this.showResumeTimerPopUp()
        })
    }

    getRemainingTime = () => {
        if (this.landingScreenInstance) {
            this.remainingTime = this.landingScreenInstance.getRemainingAppTime()
            return this.remainingTime ? Math.ceil(this.remainingTime / 60) : 0
        }

        return 0
    }

    showTimerResumeText = () => {
        let minutes = this.getRemainingTime()
        let message = CommonUtils.simpleTemplateEngine(this.staticText.timerResumeText, { time: minutes })
        this.setState({ toastText: message }, () => {
            this.showResumeTimerPopUp()
        })
    }

    showResumeTimerPopUp = () => {
        this.setState({ showResumeTimePopup: true }, () => {
            // setTimeout(() => this.setState({ showResumeTimePopup: false }), 3000)
        })
    }

    goToPracticeList() {
        this.props.delegate && this.props.delegate.showPracticeListScreen && this.props.delegate.showPracticeListScreen()
    }



    render() {



        //console.log(this.state.questionNumberIndex)
        console.log(this.state.questions, this.state.index)

        return (
            <div className="standard-homework-experience-for-clicker">
                {!this.state.showSuccessFailureScreen ?
                    <>
                        {
                            this.state.learningElos.length === 0 && this.state.questions.length > 0 &&
                            <div>
                                {
                                    this.state.questionLoading ?
                                        <>
                                            {/* <AssessmentHeader questionCount={true}
                                                currentQuestionNumber={this.state.currentQuestionNumber}
                                                totalQuestions={this.state.totalQuestions}
                                                title={this.params.title ? this.params.title : ''}
                                                
                                                categoryThemeId={1}>
                                            </AssessmentHeader> */}
                                            <div className="ml-5 mt-3">
                                                {
                                                    this.state.questions && this.state.questions.length > 0 &&
                                                    <div>
                                                        <ClickerPracticeConTextOffline.Provider value={{ index: this.state.index, disableNextStandardHomework: this.state.disableNext, showAlphabetForHomeworkAssessment: true }}>
                                                            <Question delegate={this} ref={(ref) => { this.questionComponent = ref }}
                                                                totalQuestions={this.state.totalQuestions}
                                                                questions={this.state.questions}
                                                                activePage={this.state.currentQuestionNumber}
                                                                studentList={this.state.studentList}
                                                                answer={this.state.questions[this.state.index].answer}
                                                                content={this.state.questions[this.state.index].details}
                                                                stepIndex={this.state.stepIndex}
                                                                showHint={this.state.showHint}
                                                                showSolvedExamplesModal={this.state.showSolvedExamplesModal}
                                                                showInvalidAnswerModal={this.state.showInvalidAnswerModal}
                                                                showCorrectIncorrectModal={this.state.showCorrectIncorrectModal}
                                                                isAnswerCorrect={this.isCorrect}
                                                                userAnswerForReadOnly={this.answer ? this.answer : {}}
                                                                optionsHashForReadOnly={this.optionsHash ? this.optionsHash : {}}
                                                                homeworkId={this.params.homeworkId}
                                                                showTimer={this.params.homework.showTimer}
                                                                showLeaderboard={this.params.homework.showLeaderboard}
                                                                leaderboardLimit={this.params.homework.leaderboardLimit}
                                                                classText={this.params.homework.class}
                                                                // categoryThemeId={this.state.questions[this.state.index].categoryThemeId}
                                                                categoryThemeId={1}
                                                                multiStepTimeListHash={this.multiStepTimeListHash}
                                                                // showPreviousQuestion={this.state.index < this.state.currentIndex ? true : this.state.showPreviousQuestion ? true : false}
                                                                showPreviousQuestion={(this.state.index < this.state.currentIndex) ? true : this.state.showPreviousQuestion ? true : false}
                                                                showMainQuestion={this.state.showMainQuestion} // to Show the Multi Step Main Question in index 0
                                                                isResume={this.state.isResume}
                                                            ></Question>
                                                        </ClickerPracticeConTextOffline.Provider>
                                                    </div>
                                                }
                                            </div>
                                        </>

                                        :
                                        // <></>
                                        <Loading />
                                }

                            </div>
                        }
                    </>
                    :

                    <SuccessFailureScreen
                        data={this.successFailureScreenData}
                        navigation={this.props.navigation}
                        categoryThemeId={this.params.categoryThemeId}
                        conceptsCovered={this.params.conceptsCovered}
                        homework={this.params.homework}
                        delegate={this.props.delegate} />
                    // this.params.typeOfSchoolwork === 'CLASSWORK' ? <div className="margin-for-concept-list">

                    //     <ConceptList
                    //         meta={this.successFailureScreenData}
                    //         conceptsCovered={this.params.conceptsCovered}
                    //         homework={this.params.homework}
                    //         delegate={this.props.delegate} />
                    // </div>
                    // :
                    // <div className="margin-for-concept-list">

                    //     <HomeworkConceptList meta={this.successFailureScreenData} delegate={this.props.delegate} />
                    // </div>
                }

                {/* {this.state.showResumeTimePopup ? <TimerResumePopup modal={true} onPressContinue={this.onPressResumeTimePopupContinue} message={this.state.toastText} categoryThemeId={this.params.categoryThemeId} /> : <></>} */}

                {/* {this.state.showResumeTimePopup ? <TimerToaster message={this.state.toastText} /> : <></>} */}
            </div>


        )
    }
}